const neighborhoods = [
  {
    neighborhood: 'Genesee-Moselle',
    coordinates: [
      [-78.803962665535, 42.898656777428],
      [-78.80595994296, 42.897772971381],
      [-78.806385648137, 42.897815605433],
      [-78.806630907754, 42.897823322942],
      [-78.808740057378, 42.89761501249],
      [-78.80943701863, 42.897523990568],
      [-78.811806377435, 42.897214849135],
      [-78.813993039258, 42.89692702094],
      [-78.815212008466, 42.89676803625],
      [-78.815577041667, 42.896723979508],
      [-78.815906993116, 42.896681002923],
      [-78.816666019608, 42.896582013171],
      [-78.816910984813, 42.896550964654],
      [-78.817687032354, 42.896452029727],
      [-78.818965002444, 42.896286982432],
      [-78.819911001598, 42.896165968285],
      [-78.820053962568, 42.896146965286],
      [-78.820853997171, 42.896043965908],
      [-78.821118004653, 42.896010021481],
      [-78.821766991496, 42.895928001117],
      [-78.822102994518, 42.895882013436],
      [-78.822675017205, 42.895804992502],
      [-78.823624981742, 42.895681023554],
      [-78.82457401454, 42.895547984361],
      [-78.824736014446, 42.895524016587],
      [-78.825464939923, 42.895417961619],
      [-78.825936972074, 42.895347962188],
      [-78.826350044365, 42.895286956756],
      [-78.82724500434, 42.895153004635],
      [-78.828108976063, 42.895022963819],
      [-78.828255051953, 42.895000964186],
      [-78.828720343947, 42.894931327784],
      [-78.82872193347, 42.894971237479],
      [-78.828958002141, 42.900899014371],
      [-78.8289719445, 42.903532956881],
      [-78.828982060452, 42.906516012326],
      [-78.828332006617, 42.906784036745],
      [-78.824233029483, 42.908426035264],
      [-78.824262038886, 42.910319004795],
      [-78.82427296924, 42.914450010029],
      [-78.824413055426, 42.918877957927],
      [-78.824289954048, 42.922567039187],
      [-78.823738957431, 42.92257997964],
      [-78.821529015421, 42.922598959435],
      [-78.819522994436, 42.922612974943],
      [-78.817182315467, 42.922632870561],
      [-78.81598942954, 42.920378494963],
      [-78.812107052297, 42.913282965002],
      [-78.807543335134, 42.905698375656],
      [-78.807542976326, 42.905697698494],
      [-78.805244282811, 42.901354593424],
      [-78.803962665535, 42.898656777428],
    ],
  },
  {
    neighborhood: 'Allentown',
    coordinates: [
      [-78.86897100867, 42.902196962558],
      [-78.870728031013, 42.896804033025],
      [-78.871255993667, 42.895186011833],
      [-78.871873617233, 42.893324082779],
      [-78.873049015355, 42.893525043284],
      [-78.877263954654, 42.894247956245],
      [-78.878229958987, 42.894412998681],
      [-78.87891901942, 42.89453196744],
      [-78.880117968007, 42.895771967024],
      [-78.881614023264, 42.897335002864],
      [-78.880945975876, 42.89767596699],
      [-78.883403988826, 42.898734970532],
      [-78.883066018375, 42.898906988621],
      [-78.884556046509, 42.900472979702],
      [-78.883528044099, 42.901000953667],
      [-78.882062294738, 42.901756872688],
      [-78.881686041684, 42.902343036236],
      [-78.88032000054, 42.902276959678],
      [-78.877137045268, 42.902255039355],
      [-78.873022009621, 42.90223202062],
      [-78.86897100867, 42.902196962558],
    ],
  },
  {
    neighborhood: 'West Hertel',
    coordinates: [
      [-78.878376553824, 42.958633404865],
      [-78.878418971932, 42.944065974277],
      [-78.896005687334, 42.943804654477],
      [-78.895372286068, 42.94818519006],
      [-78.892622264321, 42.961292611104],
      [-78.892360308228, 42.961055681087],
      [-78.891415940039, 42.95990752552],
      [-78.890804177971, 42.958964944016],
      [-78.890543474655, 42.958562298286],
      [-78.889127159952, 42.95856094591],
      [-78.885060037197, 42.958591288508],
      [-78.881397260092, 42.958612888875],
      [-78.880945247142, 42.958615093914],
      [-78.878376553824, 42.958633404865],
    ],
  },
  {
    neighborhood: 'Central',
    coordinates: [
      [-78.902088872515, 42.902038699938],
      [-78.902075331092, 42.90213362708],
      [-78.901862077585, 42.90193595716],
      [-78.901621136599, 42.902071240705],
      [-78.901754558994, 42.902331040331],
      [-78.901682677425, 42.902339589772],
      [-78.90074796695, 42.90250402479],
      [-78.900014978913, 42.90124699859],
      [-78.89851832062, 42.899039360605],
      [-78.897791997846, 42.898256970031],
      [-78.896389224471, 42.896797645009],
      [-78.896379021664, 42.896787026901],
      [-78.895331824388, 42.895676338876],
      [-78.893310041279, 42.893622977309],
      [-78.892570014705, 42.892908975201],
      [-78.890334001038, 42.890551030012],
      [-78.889088884358, 42.889500870614],
      [-78.883543975589, 42.883920979669],
      [-78.88018100863, 42.885245010412],
      [-78.878330505256, 42.890893551841],
      [-78.877263954654, 42.894247956245],
      [-78.873049015355, 42.893525043284],
      [-78.869651007454, 42.892944042293],
      [-78.865594971915, 42.892389966125],
      [-78.866704017282, 42.888995954162],
      [-78.867398039588, 42.886854977375],
      [-78.869107012562, 42.881570026089],
      [-78.869884034313, 42.878824953595],
      [-78.870706039354, 42.876289040269],
      [-78.871444033121, 42.873996006612],
      [-78.871783026744, 42.873006988633],
      [-78.871816987171, 42.872910524154],
      [-78.871874441072, 42.872728191975],
      [-78.871914692076, 42.87260543226],
      [-78.871986956192, 42.872385035405],
      [-78.872076023192, 42.872133965986],
      [-78.872107657833, 42.872084880684],
      [-78.872193955962, 42.871950976958],
      [-78.872279009002, 42.871846983564],
      [-78.872345367893, 42.871794957743],
      [-78.872346931229, 42.871793732192],
      [-78.872372154174, 42.871692876684],
      [-78.872249698591, 42.871608430521],
      [-78.872233006686, 42.871601028684],
      [-78.872189994804, 42.871612029924],
      [-78.872154977118, 42.871607993437],
      [-78.872103958857, 42.871584961148],
      [-78.871959998822, 42.871448028204],
      [-78.871767956329, 42.871332981846],
      [-78.871520174337, 42.871122150245],
      [-78.871319552966, 42.870988418953],
      [-78.871253761889, 42.8708827072],
      [-78.871146941671, 42.870784975519],
      [-78.871018997963, 42.870632012217],
      [-78.870849974025, 42.870382029393],
      [-78.870734966119, 42.870246005215],
      [-78.870698049468, 42.870149023941],
      [-78.870681998762, 42.870050976635],
      [-78.87062405015, 42.869924995163],
      [-78.870566987436, 42.869838777966],
      [-78.870448032296, 42.869659041269],
      [-78.870229705954, 42.869237217449],
      [-78.869862815582, 42.868647660657],
      [-78.86945331522, 42.867771013897],
      [-78.869441022472, 42.867745978747],
      [-78.869437990651, 42.867738209278],
      [-78.869409884089, 42.867678037342],
      [-78.868967408679, 42.866730769182],
      [-78.86885904898, 42.866555031006],
      [-78.868819024294, 42.866511996515],
      [-78.868741812554, 42.866461672867],
      [-78.868684021057, 42.866424006548],
      [-78.868643948161, 42.866387997474],
      [-78.868613423672, 42.866345928584],
      [-78.867995238473, 42.866451326214],
      [-78.867922521928, 42.866368106503],
      [-78.868646094325, 42.86601959829],
      [-78.868619996998, 42.865687955449],
      [-78.868542048624, 42.864876022881],
      [-78.868586729494, 42.864570802601],
      [-78.868572617429, 42.864348142634],
      [-78.868534218441, 42.863742322457],
      [-78.868451991147, 42.862873842615],
      [-78.868068319725, 42.862554048692],
      [-78.867638026333, 42.862195389454],
      [-78.867601042311, 42.862176031],
      [-78.867587974148, 42.862172286996],
      [-78.867421544565, 42.862175262107],
      [-78.86738894509, 42.862182036169],
      [-78.866795050077, 42.862242011927],
      [-78.866641966359, 42.862264026853],
      [-78.866558060436, 42.862306031033],
      [-78.86594201213, 42.862700971838],
      [-78.865745026731, 42.862847010918],
      [-78.86436697677, 42.86375003881],
      [-78.864173965725, 42.86385596395],
      [-78.86310499453, 42.864078019127],
      [-78.862723000014, 42.864132974449],
      [-78.862292037419, 42.864128987603],
      [-78.861745023495, 42.864158000994],
      [-78.861577947577, 42.864154010439],
      [-78.861100037721, 42.864095961201],
      [-78.860578956256, 42.864009025443],
      [-78.860181738143, 42.863956472679],
      [-78.860079122604, 42.863997870077],
      [-78.859922904787, 42.86397395497],
      [-78.859831066342, 42.860570649804],
      [-78.860099866085, 42.860568546498],
      [-78.860102345026, 42.86067643443],
      [-78.860195008108, 42.860694017777],
      [-78.860246157091, 42.860743826936],
      [-78.86033095372, 42.861537042518],
      [-78.860336255885, 42.861736011179],
      [-78.860409193768, 42.861702833305],
      [-78.860720589617, 42.86147628639],
      [-78.860987850946, 42.861221745994],
      [-78.861166189337, 42.860938650444],
      [-78.861308115788, 42.860616684816],
      [-78.86142005774, 42.860299828591],
      [-78.861486064169, 42.860031778889],
      [-78.861575744143, 42.859709155696],
      [-78.861604820075, 42.859424177757],
      [-78.861617054645, 42.858989909349],
      [-78.861610215853, 42.858875513474],
      [-78.861573283567, 42.858540321029],
      [-78.861428009779, 42.858050121545],
      [-78.861272193315, 42.857691484064],
      [-78.861090766401, 42.85715144165],
      [-78.861027719351, 42.856975051986],
      [-78.860996710483, 42.856705783798],
      [-78.860933407395, 42.856540363953],
      [-78.866391809137, 42.853127850039],
      [-78.866538507938, 42.853085475466],
      [-78.871660295068, 42.851720230213],
      [-78.871752703697, 42.851695823662],
      [-78.871770394543, 42.851688998583],
      [-78.872060731383, 42.852162188049],
      [-78.872286705431, 42.852530474531],
      [-78.872152077945, 42.852565410847],
      [-78.871777642073, 42.852665114196],
      [-78.869400816604, 42.853361749731],
      [-78.86922331125, 42.853595351075],
      [-78.869333662017, 42.853702974038],
      [-78.86952235966, 42.854058040124],
      [-78.869578043292, 42.854162817918],
      [-78.869646078294, 42.854143217305],
      [-78.87274214342, 42.85325123737],
      [-78.872829698715, 42.853226010413],
      [-78.872911329807, 42.853343046905],
      [-78.872934294227, 42.853375971354],
      [-78.874750222606, 42.855979380545],
      [-78.87495290095, 42.856271969403],
      [-78.87507280307, 42.856445058459],
      [-78.875207558486, 42.856690985586],
      [-78.875421586755, 42.857095736306],
      [-78.875681252924, 42.857661274798],
      [-78.875790365803, 42.858017877504],
      [-78.875965644208, 42.858409306404],
      [-78.876110463053, 42.858702287607],
      [-78.876097158199, 42.858954548891],
      [-78.875937759746, 42.85906781685],
      [-78.875184947401, 42.859338363114],
      [-78.87345272242, 42.859991876389],
      [-78.873601781715, 42.860066458641],
      [-78.873777300564, 42.860160522896],
      [-78.87383496914, 42.860249038981],
      [-78.873713902132, 42.860318875968],
      [-78.873813303974, 42.86053960867],
      [-78.874014690861, 42.860547588503],
      [-78.874176581007, 42.860692752069],
      [-78.874391141782, 42.860978510281],
      [-78.874485580246, 42.861168021644],
      [-78.874641807462, 42.861191906967],
      [-78.874710760681, 42.861115933369],
      [-78.874793718085, 42.860990862655],
      [-78.874872849918, 42.860802077307],
      [-78.87490688285, 42.860706799824],
      [-78.874924477945, 42.860591779922],
      [-78.874854165151, 42.860404333813],
      [-78.874916684014, 42.860369641936],
      [-78.875270119807, 42.860173519137],
      [-78.875714275179, 42.860014389772],
      [-78.876210545433, 42.85986139006],
      [-78.876382205336, 42.859863512877],
      [-78.876656193605, 42.85996018877],
      [-78.876932571348, 42.860276392463],
      [-78.877483773115, 42.861185493492],
      [-78.877651012414, 42.861492519739],
      [-78.877671889742, 42.861634906141],
      [-78.877720952687, 42.861758948181],
      [-78.87810455462, 42.862441841307],
      [-78.878528757585, 42.86299781628],
      [-78.878784923103, 42.863289982793],
      [-78.879015325178, 42.863562952223],
      [-78.87966126212, 42.864271887129],
      [-78.880265102604, 42.865097790251],
      [-78.880859195676, 42.865790388414],
      [-78.881280302453, 42.866192145095],
      [-78.881642811197, 42.866453052404],
      [-78.881943523869, 42.866681640511],
      [-78.882228441429, 42.866959622999],
      [-78.882365459938, 42.86716983149],
      [-78.882496530232, 42.867314119262],
      [-78.882644679062, 42.86736532757],
      [-78.882715532949, 42.867530823351],
      [-78.87925834876, 42.868690084414],
      [-78.879995036075, 42.8695494105],
      [-78.883658605047, 42.868403954667],
      [-78.884006041588, 42.868880147591],
      [-78.880427444752, 42.870060668402],
      [-78.880864562328, 42.870580243964],
      [-78.881131580904, 42.870491022567],
      [-78.881210346939, 42.870522418255],
      [-78.881486727651, 42.87063258223],
      [-78.881601210755, 42.87059991737],
      [-78.884620965819, 42.869738261978],
      [-78.884801773819, 42.869992905225],
      [-78.884791535528, 42.870113501976],
      [-78.884744349171, 42.870217184452],
      [-78.884630109737, 42.870314557262],
      [-78.884487144661, 42.870362187086],
      [-78.884306603365, 42.870420331115],
      [-78.883878914129, 42.870497667617],
      [-78.883623654128, 42.870571071939],
      [-78.8834879035, 42.870629767858],
      [-78.883455518058, 42.870739117515],
      [-78.883539391816, 42.87105641313],
      [-78.883822851244, 42.871649064211],
      [-78.884287406758, 42.871424429027],
      [-78.885272621926, 42.870948016308],
      [-78.885547104125, 42.870955666908],
      [-78.885624293293, 42.87107115009],
      [-78.88634728541, 42.871862650848],
      [-78.886628075665, 42.872311620749],
      [-78.887224456968, 42.873023815478],
      [-78.888844861763, 42.874836661125],
      [-78.889409943717, 42.875466508559],
      [-78.889884708087, 42.875646171643],
      [-78.890387026553, 42.875974315579],
      [-78.888372911017, 42.876915749347],
      [-78.8881188821, 42.876921751597],
      [-78.888077231851, 42.877201430494],
      [-78.889240204348, 42.877271542461],
      [-78.88931186059, 42.876981130614],
      [-78.889523811452, 42.876898080094],
      [-78.890107645807, 42.876669308894],
      [-78.890577911791, 42.877531809662],
      [-78.889749954461, 42.877951576483],
      [-78.888582282452, 42.877858999157],
      [-78.888510570228, 42.877945205777],
      [-78.887945667279, 42.878758262397],
      [-78.887899267652, 42.878825041971],
      [-78.887830204575, 42.878835056108],
      [-78.88789566518, 42.878977339625],
      [-78.888145691926, 42.87950089313],
      [-78.888672339422, 42.880603658438],
      [-78.889015265355, 42.881209859122],
      [-78.889459019068, 42.882157193249],
      [-78.889902786424, 42.883104523656],
      [-78.890401853209, 42.884132430423],
      [-78.890576528033, 42.884176863095],
      [-78.890697475818, 42.884366728445],
      [-78.890888912931, 42.884368323564],
      [-78.890570116076, 42.884858503477],
      [-78.889789422693, 42.884565396727],
      [-78.889772789945, 42.884439991658],
      [-78.889751102661, 42.884276483793],
      [-78.88967144531, 42.88393278768],
      [-78.889607007498, 42.883706409185],
      [-78.889460810362, 42.883263769166],
      [-78.889384750739, 42.883101255478],
      [-78.88925797776, 42.882830383324],
      [-78.889171868342, 42.882646396317],
      [-78.889160759409, 42.88264168902],
      [-78.889131709994, 42.882561692707],
      [-78.888798521331, 42.881775512901],
      [-78.888411850489, 42.881272013104],
      [-78.887942465074, 42.880688006354],
      [-78.887583943113, 42.880325697168],
      [-78.88711595875, 42.880024220932],
      [-78.886318391913, 42.87966307183],
      [-78.885802058647, 42.879490677797],
      [-78.885675168942, 42.879544154027],
      [-78.885582475435, 42.879494496698],
      [-78.885377295769, 42.879517893943],
      [-78.885410146755, 42.879623946287],
      [-78.885179871486, 42.87968113715],
      [-78.884271637167, 42.880021712171],
      [-78.884159514268, 42.880089705409],
      [-78.884245459469, 42.880321035839],
      [-78.884499485637, 42.880301203959],
      [-78.884684851459, 42.880324055389],
      [-78.884797253501, 42.880347627094],
      [-78.88492290295, 42.880425551669],
      [-78.885010728353, 42.880536100834],
      [-78.885044601267, 42.880604949755],
      [-78.885075832201, 42.880668425895],
      [-78.885157186809, 42.880689139839],
      [-78.885064228247, 42.880729046887],
      [-78.884799404388, 42.880828652005],
      [-78.883994040874, 42.881131558585],
      [-78.884147394309, 42.881346984212],
      [-78.884204213689, 42.881324378849],
      [-78.884340682621, 42.881291683231],
      [-78.884686843438, 42.881208749702],
      [-78.884813603685, 42.881215302688],
      [-78.884932728577, 42.881232772845],
      [-78.88500691593, 42.881260848892],
      [-78.885088136436, 42.881316435171],
      [-78.885176564404, 42.881388556588],
      [-78.885242182155, 42.881487940124],
      [-78.885350772163, 42.881702988833],
      [-78.885403291552, 42.881823493642],
      [-78.885489980434, 42.882022397777],
      [-78.885545319248, 42.882149370376],
      [-78.885573029911, 42.88228687017],
      [-78.885588959855, 42.882297753219],
      [-78.885502868333, 42.882507858399],
      [-78.884923658312, 42.882709346693],
      [-78.884826905495, 42.882758313469],
      [-78.884987984886, 42.882957329007],
      [-78.885648365385, 42.882721268191],
      [-78.886129958461, 42.88294493145],
      [-78.886638992308, 42.882518764468],
      [-78.886681907867, 42.882482835408],
      [-78.886883368743, 42.882484522296],
      [-78.887101075062, 42.8826618901],
      [-78.887094510619, 42.882699928422],
      [-78.887080230663, 42.882782667965],
      [-78.886361484189, 42.883413580629],
      [-78.886982469575, 42.883792146129],
      [-78.887766383031, 42.883132026867],
      [-78.887821795405, 42.883085365007],
      [-78.888047180781, 42.883061777282],
      [-78.888243382173, 42.883155920534],
      [-78.88834189944, 42.883232467812],
      [-78.888354526451, 42.883380822361],
      [-78.888351017326, 42.883411982112],
      [-78.888032762011, 42.883716797792],
      [-78.887544878773, 42.884098837091],
      [-78.887714628357, 42.884221052033],
      [-78.888095178046, 42.884224232008],
      [-78.888367235056, 42.884463093584],
      [-78.890260988523, 42.886125709425],
      [-78.889908632166, 42.886362017467],
      [-78.889836328643, 42.886410507972],
      [-78.889519529425, 42.88670145401],
      [-78.889983186422, 42.887122611643],
      [-78.890277351785, 42.886921904766],
      [-78.890550563629, 42.887110864935],
      [-78.890211303813, 42.887340637323],
      [-78.890658159527, 42.887735958527],
      [-78.890818463989, 42.887758262308],
      [-78.891579897333, 42.887864197281],
      [-78.891941457177, 42.887914497188],
      [-78.892297863688, 42.887964079779],
      [-78.892943998629, 42.888508110815],
      [-78.89326136335, 42.888775320145],
      [-78.893346825988, 42.888847274835],
      [-78.893463259541, 42.888945306911],
      [-78.893727675286, 42.889167929933],
      [-78.894164334715, 42.889545531488],
      [-78.894637710716, 42.889947047629],
      [-78.895469118601, 42.890609875623],
      [-78.896671081991, 42.891487136583],
      [-78.899343224055, 42.893353289863],
      [-78.900481162576, 42.89414637958],
      [-78.900493081742, 42.894149264177],
      [-78.900493949791, 42.894155711854],
      [-78.900685869213, 42.894314427277],
      [-78.900689214118, 42.894320628628],
      [-78.900943124079, 42.894791455625],
      [-78.90121297926, 42.895240346182],
      [-78.901220993748, 42.895245776565],
      [-78.90154745602, 42.895867038169],
      [-78.901612989959, 42.895965811838],
      [-78.901747504455, 42.896229385143],
      [-78.901958221354, 42.896616295175],
      [-78.901130218117, 42.897070703463],
      [-78.901888039004, 42.897790721638],
      [-78.901930081545, 42.898006331614],
      [-78.901947728713, 42.898079239047],
      [-78.901890136603, 42.89808617887],
      [-78.90196046167, 42.898647860057],
      [-78.901807793003, 42.898646605041],
      [-78.901858611188, 42.898740363819],
      [-78.901902053043, 42.898828569837],
      [-78.901983059898, 42.898900616762],
      [-78.902048641886, 42.89893853512],
      [-78.902026708588, 42.899088842899],
      [-78.902027991554, 42.899337959905],
      [-78.90201126933, 42.899341083406],
      [-78.901948720572, 42.899566076628],
      [-78.902003400001, 42.900287220214],
      [-78.902035691015, 42.900365277508],
      [-78.902040076441, 42.900419594465],
      [-78.902029800048, 42.900465129183],
      [-78.902007693499, 42.901120913478],
      [-78.902034431656, 42.901364393479],
      [-78.902074538071, 42.901729613451],
      [-78.902088872515, 42.902038699938],
    ],
  },
  {
    neighborhood: 'Elmwood Bryant',
    coordinates: [
      [-78.870236491887, 42.915406408528],
      [-78.869974059608, 42.915399285335],
      [-78.864481999871, 42.915348999237],
      [-78.864259636808, 42.915338882935],
      [-78.864637969174, 42.914967027309],
      [-78.865913039664, 42.911248953766],
      [-78.867589018912, 42.905811995365],
      [-78.868374999982, 42.904018959405],
      [-78.86897100867, 42.902196962558],
      [-78.873022009621, 42.90223202062],
      [-78.877137045268, 42.902255039355],
      [-78.88032000054, 42.902276959678],
      [-78.881686041684, 42.902343036236],
      [-78.881690883786, 42.902335494181],
      [-78.882017941642, 42.902995969672],
      [-78.881903023702, 42.905421960823],
      [-78.882670002423, 42.905432016431],
      [-78.883045025129, 42.905883959788],
      [-78.8844949671, 42.907465987591],
      [-78.885971009802, 42.909045038765],
      [-78.885430022184, 42.909322015491],
      [-78.8869369719, 42.910919991017],
      [-78.886138037268, 42.911323960796],
      [-78.887481942224, 42.912981044006],
      [-78.88729303061, 42.913075974999],
      [-78.888741737876, 42.914610551025],
      [-78.888150746142, 42.914946653299],
      [-78.888153972052, 42.914966011991],
      [-78.88815087373, 42.915347781806],
      [-78.886797000245, 42.915380999396],
      [-78.885666000073, 42.915410999273],
      [-78.882600999627, 42.915488998621],
      [-78.880829869389, 42.915495739401],
      [-78.877046999868, 42.915464999303],
      [-78.873514999503, 42.915428999294],
      [-78.870236491887, 42.915406408528],
    ],
  },
  {
    neighborhood: 'Fillmore-Leroy',
    coordinates: [
      [-78.834753593947, 42.928329282542],
      [-78.837316952714, 42.927068021878],
      [-78.839746962854, 42.925412027974],
      [-78.84147893999, 42.924332001635],
      [-78.84269721509, 42.923666526643],
      [-78.842704729617, 42.925628909208],
      [-78.842711975741, 42.927521002852],
      [-78.845603996172, 42.927574015194],
      [-78.846132014991, 42.927579029267],
      [-78.849586425201, 42.927627204349],
      [-78.850599483265, 42.927640573157],
      [-78.850613262874, 42.927637317313],
      [-78.850635945376, 42.927631956679],
      [-78.851053889332, 42.927643039318],
      [-78.85150499967, 42.927654998769],
      [-78.851507255404, 42.92765539138],
      [-78.851291029519, 42.927859019697],
      [-78.850967053519, 42.928164986721],
      [-78.849551051834, 42.929503006615],
      [-78.848512979191, 42.930491005152],
      [-78.848153970417, 42.93082902718],
      [-78.847482026293, 42.931463989105],
      [-78.846656999443, 42.932244017835],
      [-78.846409056378, 42.932478985003],
      [-78.845827967858, 42.933026965498],
      [-78.844796054609, 42.9339799693],
      [-78.843910951047, 42.934791980921],
      [-78.842866973241, 42.935746993898],
      [-78.842119010625, 42.936440033061],
      [-78.841572977877, 42.936948007647],
      [-78.840319939015, 42.938102973065],
      [-78.83930500021, 42.939037980516],
      [-78.839073960213, 42.939250034605],
      [-78.837992706382, 42.940245606138],
      [-78.837616593554, 42.940241408225],
      [-78.831504000025, 42.940173011582],
      [-78.82636109166, 42.940103814785],
      [-78.824899658916, 42.937213177565],
      [-78.821121785232, 42.930076609103],
      [-78.82131502234, 42.929999986299],
      [-78.822532577457, 42.929903750658],
      [-78.824823775126, 42.929755869918],
      [-78.830061928716, 42.929710168777],
      [-78.83237358626, 42.929306808786],
      [-78.834753593947, 42.928329282542],
    ],
  },
  {
    neighborhood: 'Delavan Grider',
    coordinates: [
      [-78.843415837618, 42.914668916928],
      [-78.843579058501, 42.92299097792],
      [-78.843618058769, 42.923163503982],
      [-78.84147893999, 42.924332001635],
      [-78.839746962854, 42.925412027974],
      [-78.837316952714, 42.927068021878],
      [-78.834753593947, 42.928329282542],
      [-78.83237358626, 42.929306808786],
      [-78.830061928716, 42.929710168777],
      [-78.824823775126, 42.929755869918],
      [-78.822532577457, 42.929903750658],
      [-78.82131502234, 42.929999986299],
      [-78.821121785232, 42.930076609103],
      [-78.817182315467, 42.922632870561],
      [-78.819522994436, 42.922612974943],
      [-78.821529015421, 42.922598959435],
      [-78.823738957431, 42.92257997964],
      [-78.824289954048, 42.922567039187],
      [-78.824413055426, 42.918877957927],
      [-78.82427296924, 42.914450010029],
      [-78.82907696346, 42.914499969228],
      [-78.832414000224, 42.914543003033],
      [-78.835415024761, 42.914578036945],
      [-78.839118943335, 42.914622970061],
      [-78.843415837618, 42.914668916928],
    ],
  },
  {
    neighborhood: 'Lovejoy',
    coordinates: [
      [-78.799274636219, 42.898735124702],
      [-78.79909707854, 42.895576569105],
      [-78.799396839197, 42.889775439511],
      [-78.799396349635, 42.884690337728],
      [-78.799401855087, 42.88438245922],
      [-78.799520827451, 42.877728520437],
      [-78.800222002601, 42.877726038419],
      [-78.801256977907, 42.877734038604],
      [-78.801864997397, 42.877741011408],
      [-78.802942026113, 42.87775597114],
      [-78.803969046924, 42.877767992369],
      [-78.805522982272, 42.877782003285],
      [-78.808465029451, 42.877809005215],
      [-78.815797992623, 42.877930038293],
      [-78.828727029865, 42.87843901877],
      [-78.828460008102, 42.87877101712],
      [-78.82816949612, 42.879177274094],
      [-78.827649362366, 42.879907951548],
      [-78.826874997314, 42.880996967686],
      [-78.825649993237, 42.882713030993],
      [-78.825635970626, 42.884465005142],
      [-78.825629574043, 42.884874699237],
      [-78.825464939923, 42.895417961619],
      [-78.824736014446, 42.895524016587],
      [-78.82457401454, 42.895547984361],
      [-78.823624981742, 42.895681023554],
      [-78.822675017205, 42.895804992502],
      [-78.822102994518, 42.895882013436],
      [-78.821766991496, 42.895928001117],
      [-78.821118004653, 42.896010021481],
      [-78.820853997171, 42.896043965908],
      [-78.820053962568, 42.896146965286],
      [-78.819911001598, 42.896165968285],
      [-78.818965002444, 42.896286982432],
      [-78.817687032354, 42.896452029727],
      [-78.816910984813, 42.896550964654],
      [-78.816666019608, 42.896582013171],
      [-78.815906993116, 42.896681002923],
      [-78.815577041667, 42.896723979508],
      [-78.815212008466, 42.89676803625],
      [-78.813993039258, 42.89692702094],
      [-78.811806377435, 42.897214849135],
      [-78.80943701863, 42.897523990568],
      [-78.808740057378, 42.89761501249],
      [-78.806630907754, 42.897823322942],
      [-78.806385648137, 42.897815605433],
      [-78.80595994296, 42.897772971381],
      [-78.803962665535, 42.898656777428],
      [-78.799220133658, 42.900554207603],
      [-78.799254657106, 42.899159434551],
      [-78.799271492246, 42.898801909898],
      [-78.799274636219, 42.898735124702],
    ],
  },
  {
    neighborhood: 'Black Rock',
    coordinates: [
      [-78.896005687334, 42.943804654477],
      [-78.897620212764, 42.928040632583],
      [-78.899100725754, 42.927622434954],
      [-78.899098055059, 42.927695072609],
      [-78.899151244556, 42.928125828431],
      [-78.899230504278, 42.928668920352],
      [-78.899335355293, 42.929230676807],
      [-78.899439537617, 42.929661290705],
      [-78.899657874327, 42.929979180132],
      [-78.899811803666, 42.930166103862],
      [-78.899978193923, 42.930296787082],
      [-78.900375147429, 42.930642283819],
      [-78.900886931403, 42.931006194152],
      [-78.900974345234, 42.930994608927],
      [-78.901103497324, 42.930977491189],
      [-78.90133266771, 42.930920649891],
      [-78.902894186327, 42.93213406726],
      [-78.903764447687, 42.932787354629],
      [-78.903586847475, 42.932956464525],
      [-78.903694461417, 42.933046143473],
      [-78.905469025468, 42.934524910671],
      [-78.905648285907, 42.934674284583],
      [-78.905891583376, 42.934879682673],
      [-78.906262954775, 42.935197127879],
      [-78.906390734988, 42.935252971324],
      [-78.906557299829, 42.935411747249],
      [-78.907057292671, 42.935944277569],
      [-78.907621580579, 42.936579664736],
      [-78.908058045001, 42.937149840123],
      [-78.908598038695, 42.938010108853],
      [-78.908816748188, 42.938384184101],
      [-78.908958767632, 42.938721006583],
      [-78.909100688648, 42.939039094802],
      [-78.9093459916, 42.939619176485],
      [-78.90973278157, 42.940433038479],
      [-78.909811258585, 42.940807511422],
      [-78.909864435558, 42.941219526036],
      [-78.909943905904, 42.941781343883],
      [-78.909958784136, 42.94218409913],
      [-78.909963438867, 42.943064622995],
      [-78.909953660676, 42.943626694375],
      [-78.909946007119, 42.94381048388],
      [-78.895372286068, 42.94818519006],
      [-78.896005687334, 42.943804654477],
    ],
  },
  {
    neighborhood: 'Hopkins-Tifft',
    coordinates: [
      [-78.866391809137, 42.853127850039],
      [-78.860933407395, 42.856540363953],
      [-78.860810663196, 42.856363224945],
      [-78.860659358881, 42.856252376578],
      [-78.860234999034, 42.856054015056],
      [-78.859760002385, 42.855865036651],
      [-78.859668995769, 42.855853973782],
      [-78.859471992174, 42.855876021214],
      [-78.858050005435, 42.856414992312],
      [-78.857039966685, 42.856819038527],
      [-78.85675197511, 42.856903035411],
      [-78.856434956193, 42.85696901255],
      [-78.854841998917, 42.857220008735],
      [-78.854787044286, 42.85727102256],
      [-78.854758039323, 42.857326023166],
      [-78.85475798148, 42.857387970615],
      [-78.854889052341, 42.857827977871],
      [-78.854955052418, 42.857969993233],
      [-78.855235971237, 42.858286996676],
      [-78.855491012853, 42.858498988267],
      [-78.855796998016, 42.858683961093],
      [-78.855978966584, 42.858827015949],
      [-78.856041027573, 42.858892000446],
      [-78.857018065909, 42.860295601513],
      [-78.85709502597, 42.860451013555],
      [-78.857193051898, 42.860764999535],
      [-78.857321051702, 42.861066988393],
      [-78.857342983191, 42.861191041101],
      [-78.857327992685, 42.86130004216],
      [-78.85728503199, 42.861406025066],
      [-78.857247995758, 42.86182496011],
      [-78.85728802685, 42.862149005154],
      [-78.857284984284, 42.862269038678],
      [-78.857241009875, 42.862399996246],
      [-78.857181972549, 42.862521018018],
      [-78.857112979974, 42.862607981006],
      [-78.856971020202, 42.862728018922],
      [-78.856831901472, 42.862801499186],
      [-78.856635126632, 42.862897288586],
      [-78.856502864684, 42.862959606384],
      [-78.856343960583, 42.863020006161],
      [-78.856055958737, 42.863066996551],
      [-78.85584065311, 42.863110179005],
      [-78.855402945827, 42.863197965714],
      [-78.855292588253, 42.863206482069],
      [-78.855228388586, 42.863192879991],
      [-78.855162984787, 42.863189040985],
      [-78.855052053889, 42.863209978887],
      [-78.854983052076, 42.863234004909],
      [-78.854630009404, 42.863295970028],
      [-78.854339054694, 42.863329009593],
      [-78.854046993888, 42.863306982413],
      [-78.853946027118, 42.863314978341],
      [-78.853840018311, 42.86335600728],
      [-78.853757045978, 42.863405637386],
      [-78.853546035347, 42.863476033613],
      [-78.853335009932, 42.863520962094],
      [-78.852741951615, 42.863584978813],
      [-78.852375024619, 42.863598964199],
      [-78.852249668991, 42.8635917211],
      [-78.851882921116, 42.863630974729],
      [-78.851502283347, 42.86362615405],
      [-78.851212503194, 42.863567609239],
      [-78.850982432282, 42.863509819855],
      [-78.850783636453, 42.863392063125],
      [-78.850660386675, 42.86323685673],
      [-78.850757234542, 42.863118263454],
      [-78.850716049826, 42.863104994886],
      [-78.850661992382, 42.863143010725],
      [-78.850635989961, 42.863148028078],
      [-78.850532502459, 42.863112690003],
      [-78.850316330119, 42.863038873424],
      [-78.850269617304, 42.863028869201],
      [-78.850097437994, 42.863048637054],
      [-78.849329540496, 42.862687701835],
      [-78.848969340729, 42.862134394903],
      [-78.84881754205, 42.861923946424],
      [-78.848767245627, 42.861840998265],
      [-78.848725969237, 42.861692315364],
      [-78.84863893242, 42.861268680653],
      [-78.848548140587, 42.861004131739],
      [-78.848448715526, 42.860788864018],
      [-78.848198518476, 42.860360450987],
      [-78.848178443842, 42.860326077267],
      [-78.848061280408, 42.860125456386],
      [-78.847893523789, 42.859958704485],
      [-78.847660028215, 42.859730754578],
      [-78.847514015359, 42.859591713995],
      [-78.847130940966, 42.859060056483],
      [-78.846739766416, 42.858555730051],
      [-78.846413549679, 42.858145514848],
      [-78.846245934988, 42.857973272362],
      [-78.846129130766, 42.857862041119],
      [-78.845974621092, 42.857766787056],
      [-78.845812517627, 42.857676927246],
      [-78.845677002566, 42.857684975277],
      [-78.845561030386, 42.857732995276],
      [-78.845440982173, 42.85780996408],
      [-78.8452619708, 42.857977962663],
      [-78.845174943073, 42.8580900158],
      [-78.845139020453, 42.858153980739],
      [-78.845128016199, 42.858228992091],
      [-78.845186015874, 42.858538031539],
      [-78.845294991498, 42.858850039399],
      [-78.845367983784, 42.859161996261],
      [-78.845414961518, 42.859271972952],
      [-78.84545196976, 42.859321959739],
      [-78.845603960556, 42.85943398607],
      [-78.845644054917, 42.85951196097],
      [-78.845633005968, 42.859600029342],
      [-78.845644057245, 42.859639994788],
      [-78.845739016051, 42.859625995631],
      [-78.845768023237, 42.859626010169],
      [-78.845912978526, 42.859804001004],
      [-78.846110000631, 42.860095037838],
      [-78.846214998944, 42.860275992595],
      [-78.846251990519, 42.86036703668],
      [-78.846262960231, 42.860764005034],
      [-78.84625502822, 42.86091598506],
      [-78.846232986284, 42.861028013929],
      [-78.846160946532, 42.861142984283],
      [-78.845959512869, 42.861294221802],
      [-78.845869983703, 42.861353016553],
      [-78.845683969119, 42.861504955511],
      [-78.845557053323, 42.861633027065],
      [-78.845092022804, 42.862014041529],
      [-78.844903058285, 42.862155993437],
      [-78.844387757894, 42.862459229577],
      [-78.844326968183, 42.862495000914],
      [-78.84380451068, 42.862829971994],
      [-78.843572008012, 42.862979037986],
      [-78.843236038246, 42.8631800429],
      [-78.843027006409, 42.863272965916],
      [-78.842675024334, 42.863431018801],
      [-78.842093612053, 42.863732684757],
      [-78.842071007872, 42.863775995297],
      [-78.842107953846, 42.863821032924],
      [-78.842102959418, 42.863847041837],
      [-78.842062921236, 42.863868876376],
      [-78.841905017266, 42.863954986808],
      [-78.841662619187, 42.864040684539],
      [-78.841625001227, 42.864053983824],
      [-78.841161960408, 42.864173986015],
      [-78.840716983287, 42.864236026095],
      [-78.84057505467, 42.864225037323],
      [-78.84040299674, 42.864195972874],
      [-78.840005907491, 42.864090051945],
      [-78.839576006543, 42.8639659717],
      [-78.839206970733, 42.863806032867],
      [-78.838393984613, 42.863482004645],
      [-78.837624943324, 42.863150011363],
      [-78.837522987616, 42.863076991766],
      [-78.837352052628, 42.86299296143],
      [-78.833888049664, 42.861568992391],
      [-78.832677397614, 42.861052465742],
      [-78.832620821237, 42.861029383801],
      [-78.832542309602, 42.860997352714],
      [-78.832440067174, 42.860946522466],
      [-78.832225062511, 42.86083963264],
      [-78.831788537635, 42.860674889543],
      [-78.831470888282, 42.860577477116],
      [-78.831368991406, 42.860571005618],
      [-78.831233977972, 42.860548968802],
      [-78.831084049088, 42.860544989338],
      [-78.830924055281, 42.860586005858],
      [-78.83069396471, 42.860673039252],
      [-78.82954205251, 42.861055035039],
      [-78.828349999319, 42.861466995339],
      [-78.828040010763, 42.86159802636],
      [-78.827877974657, 42.861710956662],
      [-78.827662228512, 42.861778422001],
      [-78.826666397675, 42.860894193321],
      [-78.822381999872, 42.859490998894],
      [-78.822428291175, 42.859416130306],
      [-78.822543961787, 42.859229051145],
      [-78.822577999585, 42.859173998679],
      [-78.822654393538, 42.858956188499],
      [-78.822914254833, 42.858204570484],
      [-78.823147709315, 42.857524533731],
      [-78.823437851924, 42.856683267513],
      [-78.823559786203, 42.856329713996],
      [-78.823603999537, 42.8563639991],
      [-78.823607790455, 42.85607589323],
      [-78.823601943156, 42.856063974789],
      [-78.82368897116, 42.847736956894],
      [-78.823738945159, 42.843331971679],
      [-78.823840941488, 42.835558988378],
      [-78.82389686097, 42.832044501523],
      [-78.823907804485, 42.83204455235],
      [-78.824004903334, 42.832052037178],
      [-78.824816007545, 42.832020845121],
      [-78.825011618547, 42.832013321499],
      [-78.823985142463, 42.831438843108],
      [-78.823938927267, 42.830456963543],
      [-78.823967053844, 42.829058367083],
      [-78.823994172553, 42.827760611846],
      [-78.824011097831, 42.826958496784],
      [-78.824014244933, 42.826810708112],
      [-78.830195999455, 42.826840574386],
      [-78.830194819608, 42.826544063071],
      [-78.831371270216, 42.826588962963],
      [-78.832596300189, 42.826693047799],
      [-78.832608702638, 42.826683863642],
      [-78.832885543116, 42.826718786486],
      [-78.832858467218, 42.82659395453],
      [-78.832908622779, 42.826030484617],
      [-78.834645189746, 42.826228905563],
      [-78.835359606226, 42.828643993831],
      [-78.83609226134, 42.830492627104],
      [-78.83646975963, 42.831317903793],
      [-78.836654805806, 42.831857057029],
      [-78.836700673382, 42.831861360376],
      [-78.836710559151, 42.831950110277],
      [-78.836743030478, 42.832009341134],
      [-78.836913216048, 42.832011083515],
      [-78.852939035167, 42.832173982527],
      [-78.853625085051, 42.832172365139],
      [-78.853728544274, 42.832185181423],
      [-78.860142911487, 42.832212996398],
      [-78.860289490742, 42.832158611004],
      [-78.86052049433, 42.832976115109],
      [-78.86018574531, 42.832921060252],
      [-78.860251576626, 42.832801717722],
      [-78.859793340949, 42.832837595517],
      [-78.856710809832, 42.833020614414],
      [-78.855724096042, 42.833096501272],
      [-78.855358955858, 42.833199677826],
      [-78.854946120405, 42.833316329385],
      [-78.854503839307, 42.833441299805],
      [-78.854603352423, 42.833627496453],
      [-78.854739585187, 42.833882396197],
      [-78.854928964332, 42.833881947159],
      [-78.855071504197, 42.833871288733],
      [-78.855314107485, 42.833853146537],
      [-78.85563873415, 42.833761615547],
      [-78.856153443961, 42.833662094167],
      [-78.856543176232, 42.833619810126],
      [-78.857183861227, 42.833626137755],
      [-78.857475270539, 42.833629015259],
      [-78.857638187748, 42.833679328779],
      [-78.857976027803, 42.833687861547],
      [-78.858148291129, 42.833692211357],
      [-78.858701909782, 42.833696263788],
      [-78.8593141833, 42.833744991064],
      [-78.859881174687, 42.833817212428],
      [-78.860281250501, 42.833756764541],
      [-78.860359941807, 42.833760709844],
      [-78.860487750361, 42.833767118078],
      [-78.860500381153, 42.833824969628],
      [-78.860502776205, 42.833930646394],
      [-78.860541763809, 42.834378485098],
      [-78.860586454778, 42.834610774981],
      [-78.86056163024, 42.834714728878],
      [-78.860448169121, 42.834966268627],
      [-78.860454366863, 42.835152393355],
      [-78.860526076178, 42.835339027475],
      [-78.860651498992, 42.835706508355],
      [-78.860808466195, 42.836243787871],
      [-78.860987467534, 42.836811115585],
      [-78.861099004102, 42.837262212304],
      [-78.861062484623, 42.837547112046],
      [-78.860919189202, 42.837611166995],
      [-78.860383561333, 42.837856889275],
      [-78.859963829287, 42.837933946506],
      [-78.859748106941, 42.837903805641],
      [-78.859618621721, 42.837899109272],
      [-78.859234962557, 42.837946620362],
      [-78.858459054182, 42.838134590056],
      [-78.857846391835, 42.838355579763],
      [-78.858015768289, 42.838783684757],
      [-78.858098954292, 42.838993936381],
      [-78.858099545046, 42.839127265287],
      [-78.858143935748, 42.839359318093],
      [-78.858230338011, 42.839597778679],
      [-78.85828098981, 42.839737572553],
      [-78.858316337216, 42.839835125673],
      [-78.858786445099, 42.839849719131],
      [-78.859615034051, 42.839607500162],
      [-78.859671755639, 42.83959091879],
      [-78.860088046121, 42.839469222276],
      [-78.860269598211, 42.839357189948],
      [-78.860762030962, 42.839227064294],
      [-78.862181850203, 42.838851861043],
      [-78.862355522357, 42.839084510142],
      [-78.862991606876, 42.838948040924],
      [-78.863043571798, 42.839130718239],
      [-78.860312274623, 42.839969879326],
      [-78.860144531972, 42.840121430813],
      [-78.860004082795, 42.840221223123],
      [-78.859719168808, 42.840585882996],
      [-78.859602589495, 42.840954244753],
      [-78.859597624963, 42.841168329483],
      [-78.859595451398, 42.841262016197],
      [-78.859612034346, 42.841303149976],
      [-78.859950413798, 42.842142504409],
      [-78.860113717231, 42.842562453798],
      [-78.86051239988, 42.843587681218],
      [-78.860702412339, 42.843848802422],
      [-78.860688608253, 42.843860903429],
      [-78.860789499771, 42.844114556864],
      [-78.860868337341, 42.844312760045],
      [-78.860998569858, 42.844391711258],
      [-78.861327433222, 42.844277527664],
      [-78.861984119652, 42.844075458554],
      [-78.863382548234, 42.843717917428],
      [-78.863751392301, 42.843613663921],
      [-78.864059859042, 42.8438949912],
      [-78.866212066238, 42.847020708557],
      [-78.868215278829, 42.84992971131],
      [-78.867152667879, 42.850684736401],
      [-78.867026318842, 42.850661213292],
      [-78.866940094877, 42.850517463356],
      [-78.866986020356, 42.850468646364],
      [-78.867124872687, 42.850365414351],
      [-78.867692147473, 42.849943658103],
      [-78.867830198798, 42.849841018665],
      [-78.865870348697, 42.846948264681],
      [-78.865512232286, 42.846449846873],
      [-78.865408534435, 42.846415627231],
      [-78.862367379305, 42.847195304719],
      [-78.862229469463, 42.847347233782],
      [-78.862270006359, 42.847533722672],
      [-78.86233447498, 42.847644876136],
      [-78.862432045342, 42.847777815426],
      [-78.862538277074, 42.847913791585],
      [-78.862780214674, 42.848363232685],
      [-78.863659643151, 42.849996863163],
      [-78.863779232115, 42.850192888425],
      [-78.863955911169, 42.850288674607],
      [-78.864103170167, 42.850367581369],
      [-78.864369917768, 42.850442659524],
      [-78.864479602731, 42.850532023242],
      [-78.864704981211, 42.850680615769],
      [-78.865387058412, 42.851954032787],
      [-78.86540543011, 42.851994215102],
      [-78.865370204239, 42.85220783047],
      [-78.865336221646, 42.852372053571],
      [-78.865427950402, 42.852581942528],
      [-78.865778015086, 42.852905217249],
      [-78.865903728932, 42.852950882588],
      [-78.866016181946, 42.852930487626],
      [-78.86626194584, 42.85295037158],
      [-78.866391809137, 42.853127850039],
    ],
  },
  {
    neighborhood: 'Lower West Side',
    coordinates: [
      [-78.890334001038, 42.890551030012],
      [-78.892570014705, 42.892908975201],
      [-78.893310041279, 42.893622977309],
      [-78.895331824388, 42.895676338876],
      [-78.896379021664, 42.896787026901],
      [-78.896389223251, 42.896797645912],
      [-78.896339999848, 42.896825998809],
      [-78.894019038576, 42.897999031583],
      [-78.892986162347, 42.896900232989],
      [-78.892546958037, 42.896433002966],
      [-78.884556046509, 42.900472979702],
      [-78.883066018375, 42.898906988621],
      [-78.883403988826, 42.898734970532],
      [-78.880945975876, 42.89767596699],
      [-78.881614023264, 42.897335002864],
      [-78.880117968007, 42.895771967024],
      [-78.87891901942, 42.89453196744],
      [-78.878229958987, 42.894412998681],
      [-78.877263954654, 42.894247956245],
      [-78.878330505256, 42.890893551841],
      [-78.88018100863, 42.885245010412],
      [-78.883543975589, 42.883920979669],
      [-78.889088884358, 42.889500870614],
      [-78.890334001038, 42.890551030012],
    ],
  },
  {
    neighborhood: 'Schiller Park',
    coordinates: [
      [-78.799220133658, 42.900554207603],
      [-78.803962665535, 42.898656777428],
      [-78.805244282811, 42.901354593424],
      [-78.807543335134, 42.905698375656],
      [-78.812107052297, 42.913282965002],
      [-78.81598942954, 42.920378494963],
      [-78.817182635003, 42.922633473954],
      [-78.817116055525, 42.922634040242],
      [-78.812578976586, 42.922669037514],
      [-78.805890992037, 42.92273497051],
      [-78.79985904759, 42.922778974843],
      [-78.799151046303, 42.922785040605],
      [-78.799120146116, 42.922784592933],
      [-78.799124280725, 42.922287047874],
      [-78.798987228707, 42.919928187288],
      [-78.79898454966, 42.918910252639],
      [-78.799003553651, 42.918725674959],
      [-78.798934201403, 42.918583230045],
      [-78.799056285336, 42.916256885274],
      [-78.798983894333, 42.913696647534],
      [-78.799101402607, 42.912094817863],
      [-78.799062794924, 42.909616362533],
      [-78.79911278782, 42.908066606061],
      [-78.799154999911, 42.906309090473],
      [-78.79915499946, 42.905040998926],
      [-78.799155000402, 42.904535409449],
      [-78.799202967292, 42.904518119415],
      [-78.799155703052, 42.903157105858],
      [-78.799220133658, 42.900554207603],
    ],
  },
  {
    neighborhood: 'Kensington-Bailey',
    coordinates: [
      [-78.813689992932, 42.948945158845],
      [-78.813681041659, 42.948944980611],
      [-78.813462996691, 42.948941000924],
      [-78.813453648676, 42.948954719152],
      [-78.813398603819, 42.949035509552],
      [-78.813363756096, 42.949074709126],
      [-78.813299964627, 42.94913695827],
      [-78.813275087858, 42.949157295435],
      [-78.813213044915, 42.949208016495],
      [-78.813158778754, 42.949235407301],
      [-78.813105854334, 42.949262119329],
      [-78.813045770773, 42.949292445649],
      [-78.812951175988, 42.949335263202],
      [-78.812899045257, 42.949356968359],
      [-78.812787038352, 42.949385397488],
      [-78.812675155298, 42.949411565824],
      [-78.812650021754, 42.949414975769],
      [-78.8124980497, 42.94943697163],
      [-78.812059809901, 42.949439054402],
      [-78.811648054005, 42.94944100976],
      [-78.81153703712, 42.949462963162],
      [-78.811445959593, 42.949480972502],
      [-78.811353316169, 42.949512005563],
      [-78.811234016489, 42.949551965918],
      [-78.811173109711, 42.949590005014],
      [-78.811125847487, 42.94961952252],
      [-78.811088371209, 42.949642927899],
      [-78.811126723573, 42.949610519551],
      [-78.803384059554, 42.949454174734],
      [-78.798913949671, 42.949398638379],
      [-78.798929169443, 42.947750026656],
      [-78.79893866872, 42.944000306613],
      [-78.798911106078, 42.942573480345],
      [-78.798949034939, 42.940499456557],
      [-78.798893085522, 42.938731702401],
      [-78.799027555829, 42.937852180904],
      [-78.799019700154, 42.937340123088],
      [-78.799019800458, 42.936566354237],
      [-78.799017712878, 42.935834433187],
      [-78.798858149291, 42.935456080855],
      [-78.799017456589, 42.935092563019],
      [-78.799007141902, 42.934410389659],
      [-78.798999412613, 42.93380092442],
      [-78.799030872393, 42.933223271805],
      [-78.8021160241, 42.933008003694],
      [-78.806658991113, 42.933055968174],
      [-78.810566979195, 42.93307197845],
      [-78.812500001474, 42.93292198598],
      [-78.813646014228, 42.932484982054],
      [-78.81579100063, 42.931780399639],
      [-78.817374049757, 42.931073996986],
      [-78.819325979403, 42.930521961965],
      [-78.820957986707, 42.929915040946],
      [-78.821036266931, 42.929915040469],
      [-78.824899658916, 42.937213177565],
      [-78.82636109166, 42.940103814785],
      [-78.826075221261, 42.940099961668],
      [-78.825007969251, 42.940085980833],
      [-78.821567943393, 42.940108035252],
      [-78.81363404837, 42.940208967426],
      [-78.813647957795, 42.942495992133],
      [-78.813668941908, 42.947423034133],
      [-78.813689992932, 42.948945158845],
    ],
  },
  {
    neighborhood: 'Ellicott',
    coordinates: [
      [-78.845980732022, 42.868471969947],
      [-78.845995000221, 42.868474998881],
      [-78.847549999684, 42.868751998658],
      [-78.854870999989, 42.870054998612],
      [-78.861630999536, 42.871232999499],
      [-78.864423000499, 42.871720999115],
      [-78.868011053986, 42.872344958438],
      [-78.869207001335, 42.872550018622],
      [-78.869857045327, 42.87266397261],
      [-78.871783026744, 42.873006988633],
      [-78.871444033121, 42.873996006612],
      [-78.870706039354, 42.876289040269],
      [-78.869884034313, 42.878824953595],
      [-78.869107012562, 42.881570026089],
      [-78.864773016811, 42.880818957175],
      [-78.859942952056, 42.879983991168],
      [-78.857515016405, 42.879562994926],
      [-78.854345982553, 42.879012972459],
      [-78.854094024254, 42.879771030066],
      [-78.853912023388, 42.880638015259],
      [-78.848933952303, 42.879781010365],
      [-78.845671056167, 42.87920896582],
      [-78.844084998723, 42.878928989814],
      [-78.844075572506, 42.876342520863],
      [-78.844090995735, 42.874301031351],
      [-78.844952944622, 42.871645015152],
      [-78.845980732022, 42.868471969947],
    ],
  },
  {
    neighborhood: 'Kenfield',
    coordinates: [
      [-78.799120146116, 42.922784592933],
      [-78.799151046303, 42.922785040605],
      [-78.79985904759, 42.922778974843],
      [-78.805890992037, 42.92273497051],
      [-78.812578976586, 42.922669037514],
      [-78.817116055525, 42.922634040242],
      [-78.817182635003, 42.922633473954],
      [-78.821036266931, 42.929915040469],
      [-78.820957986707, 42.929915040946],
      [-78.819325979403, 42.930521961965],
      [-78.817374049757, 42.931073996986],
      [-78.81579100063, 42.931780399639],
      [-78.813646014228, 42.932484982054],
      [-78.812500001474, 42.93292198598],
      [-78.810566979195, 42.93307197845],
      [-78.806658991113, 42.933055968174],
      [-78.8021160241, 42.933008003694],
      [-78.799030872393, 42.933223271805],
      [-78.799035823249, 42.933132382151],
      [-78.798957501995, 42.932759021397],
      [-78.79895544423, 42.929894090367],
      [-78.798905536467, 42.925219669191],
      [-78.798896696106, 42.924423964652],
      [-78.798894582068, 42.924219550149],
      [-78.798901081583, 42.924075485246],
      [-78.798920538006, 42.92363231425],
      [-78.798932195198, 42.923362021129],
      [-78.798948203066, 42.923268013752],
      [-78.799012232718, 42.922893356141],
      [-78.799120133146, 42.92278614133],
      [-78.799120146116, 42.922784592933],
    ],
  },
  {
    neighborhood: 'Masten Park',
    coordinates: [
      [-78.845003958758, 42.904601999923],
      [-78.845706368871, 42.903716034625],
      [-78.847064976064, 42.903747980986],
      [-78.848082951884, 42.903767019716],
      [-78.853977028192, 42.903831004054],
      [-78.859737012713, 42.903901011416],
      [-78.862574030026, 42.903944020501],
      [-78.866018006266, 42.903963011608],
      [-78.866769041059, 42.90406303072],
      [-78.867012992094, 42.904003997751],
      [-78.868374999982, 42.904018959405],
      [-78.867589018912, 42.905811995365],
      [-78.865913039664, 42.911248953766],
      [-78.864637969174, 42.914967027309],
      [-78.857280993474, 42.922197009179],
      [-78.854011958806, 42.925288047211],
      [-78.853994641744, 42.925108765091],
      [-78.853993020902, 42.924871994053],
      [-78.853990959519, 42.924574039948],
      [-78.85399300957, 42.923763005887],
      [-78.853992982461, 42.922952042337],
      [-78.85399308455, 42.922872108268],
      [-78.8539940366, 42.922126995827],
      [-78.853989004433, 42.914962993454],
      [-78.849106974488, 42.914725023379],
      [-78.843615004727, 42.914671042504],
      [-78.843417041609, 42.914668929497],
      [-78.843314626232, 42.910705701172],
      [-78.843354055544, 42.908849986372],
      [-78.843585027626, 42.907879000366],
      [-78.844493831908, 42.906006491531],
      [-78.845003958758, 42.904601999923],
    ],
  },
  {
    neighborhood: 'Grant-Amherst',
    coordinates: [
      [-78.87837126075, 42.944103172531],
      [-78.878375057157, 42.942738375655],
      [-78.878575966658, 42.940564966532],
      [-78.878602945742, 42.938570994535],
      [-78.878437132874, 42.937115270958],
      [-78.87828844365, 42.936333661469],
      [-78.878190019179, 42.935808989245],
      [-78.877835895162, 42.934821487856],
      [-78.877473547014, 42.934186895878],
      [-78.877474055727, 42.934186953985],
      [-78.878498676599, 42.934351515336],
      [-78.879356000012, 42.934686999083],
      [-78.8798379682, 42.93495803693],
      [-78.880376000155, 42.935566999199],
      [-78.881189034642, 42.936448016693],
      [-78.882217000318, 42.936960998988],
      [-78.883761039518, 42.937262010987],
      [-78.885953826734, 42.937314297237],
      [-78.887571790115, 42.937172738575],
      [-78.888297999405, 42.936904999107],
      [-78.889264482823, 42.936266290228],
      [-78.890825886383, 42.935165421582],
      [-78.892022999789, 42.934320998849],
      [-78.892652657735, 42.933733267625],
      [-78.892972000012, 42.933278999489],
      [-78.893102771485, 42.932959279227],
      [-78.893346999955, 42.932315998866],
      [-78.893712999918, 42.931616999394],
      [-78.894397062065, 42.93097256019],
      [-78.895099998855, 42.930474006505],
      [-78.895860656247, 42.929529292771],
      [-78.89656300708, 42.92867743667],
      [-78.896921476734, 42.928430998038],
      [-78.89759401771, 42.92804803135],
      [-78.897620212764, 42.928040632583],
      [-78.896005687334, 42.943804654477],
      [-78.878418971932, 42.944065974277],
      [-78.878418784214, 42.944130320191],
      [-78.87837126075, 42.944103172531],
    ],
  },
  {
    neighborhood: 'Riverside',
    coordinates: [
      [-78.895372286068, 42.94818519006],
      [-78.909946007119, 42.94381048388],
      [-78.909908402875, 42.944713442536],
      [-78.909848362753, 42.945416168621],
      [-78.909789931239, 42.945901796538],
      [-78.909738522336, 42.945922322149],
      [-78.909341003271, 42.945923454943],
      [-78.909341991876, 42.946110799867],
      [-78.909396851452, 42.946841301095],
      [-78.909424776806, 42.947300223651],
      [-78.909479687958, 42.948040092148],
      [-78.909534798333, 42.948817428584],
      [-78.909576069921, 42.949388722391],
      [-78.909665727263, 42.949463405883],
      [-78.909755532093, 42.949566190803],
      [-78.90967976577, 42.949706918221],
      [-78.909552793595, 42.949810321101],
      [-78.909541129974, 42.950016437163],
      [-78.909492398603, 42.950447475956],
      [-78.909519139289, 42.950681584475],
      [-78.909585123634, 42.951102929613],
      [-78.909715513613, 42.951645866301],
      [-78.909820054544, 42.952123306003],
      [-78.910026663999, 42.952609820117],
      [-78.910258930632, 42.953124363342],
      [-78.91037469341, 42.953311380168],
      [-78.910475043872, 42.953324486768],
      [-78.910515069034, 42.953329714229],
      [-78.910509319496, 42.953401783584],
      [-78.910503110315, 42.953479626406],
      [-78.910491101926, 42.953620172021],
      [-78.910594411425, 42.953863428894],
      [-78.911071122815, 42.954780068951],
      [-78.911160491494, 42.95479854734],
      [-78.911250555293, 42.954948167331],
      [-78.911238101963, 42.955004407688],
      [-78.911315065036, 42.955088493771],
      [-78.91168703455, 42.955490225044],
      [-78.912148429366, 42.955919800125],
      [-78.912353073831, 42.956031620544],
      [-78.912459531075, 42.956084011054],
      [-78.912188300694, 42.956288219355],
      [-78.912044096177, 42.956654594486],
      [-78.908689038012, 42.959133643152],
      [-78.907813116012, 42.959777503301],
      [-78.906863211138, 42.96047575667],
      [-78.906067731022, 42.961060384266],
      [-78.905294599076, 42.961634996101],
      [-78.903724050026, 42.962792503449],
      [-78.898814782426, 42.966411550971],
      [-78.896904495921, 42.965002005428],
      [-78.89679537593, 42.96491931487],
      [-78.894858804652, 42.963302635143],
      [-78.894163799897, 42.962724886487],
      [-78.89344864387, 42.962130725999],
      [-78.892812338989, 42.961612832381],
      [-78.892627231235, 42.961297104136],
      [-78.892622264321, 42.961292611104],
      [-78.895372286068, 42.94818519006],
    ],
  },
  {
    neighborhood: 'Seneca-Cazenovia',
    coordinates: [
      [-78.814177478912, 42.865305199031],
      [-78.813583946253, 42.865071044522],
      [-78.813553001147, 42.865072521004],
      [-78.813549527374, 42.86504730546],
      [-78.813288283679, 42.86489990983],
      [-78.813102379177, 42.86475549972],
      [-78.812799649434, 42.864481853904],
      [-78.81240354188, 42.864140653024],
      [-78.812162430992, 42.863945964353],
      [-78.811883114256, 42.863684435833],
      [-78.811737503067, 42.863544165097],
      [-78.811556546388, 42.86345885592],
      [-78.811151546843, 42.863434105064],
      [-78.810889926615, 42.863494322921],
      [-78.81066331336, 42.863549454618],
      [-78.810471264525, 42.863653992829],
      [-78.810344999888, 42.86371999936],
      [-78.810020999543, 42.863987999442],
      [-78.809776999625, 42.864197999081],
      [-78.807413316036, 42.864642246917],
      [-78.802174954812, 42.864825010054],
      [-78.80092952399, 42.864858236286],
      [-78.800076370147, 42.864794083999],
      [-78.800000486891, 42.864787926041],
      [-78.800004151485, 42.86472686308],
      [-78.80005546999, 42.864457365219],
      [-78.800163144064, 42.861517421198],
      [-78.800132148879, 42.861014863615],
      [-78.80022033538, 42.857726830563],
      [-78.800286249244, 42.855749265624],
      [-78.800338544582, 42.854180209486],
      [-78.800383353653, 42.852750728514],
      [-78.800416950774, 42.851678922735],
      [-78.800474632277, 42.849838647025],
      [-78.800506541561, 42.848820569512],
      [-78.800540047726, 42.847751525034],
      [-78.800580630417, 42.84553352726],
      [-78.799342510756, 42.846389828678],
      [-78.799165166687, 42.84637830259],
      [-78.796824738945, 42.845433847204],
      [-78.7984766732, 42.843058646699],
      [-78.79864888789, 42.843184296587],
      [-78.798722174913, 42.843316352032],
      [-78.799101087544, 42.843376376208],
      [-78.799368058991, 42.843358009563],
      [-78.799600893848, 42.843296832453],
      [-78.799887142825, 42.843305927491],
      [-78.800188391675, 42.843302866416],
      [-78.800396843652, 42.843312473887],
      [-78.800635139234, 42.84332345661],
      [-78.801086655916, 42.843319025818],
      [-78.801343802564, 42.843268517057],
      [-78.801799958997, 42.843203337945],
      [-78.80213487602, 42.843177688268],
      [-78.802484318722, 42.843141292581],
      [-78.8028048206, 42.843158542858],
      [-78.803144882474, 42.843215055103],
      [-78.803543447633, 42.843339336532],
      [-78.803747465601, 42.843367526263],
      [-78.804053645522, 42.843452684205],
      [-78.804267628389, 42.843552309501],
      [-78.804476770444, 42.843655516754],
      [-78.804603426008, 42.843773174194],
      [-78.804759391147, 42.843940793354],
      [-78.804881537027, 42.844154925063],
      [-78.805018479035, 42.844433337659],
      [-78.805106959907, 42.844736853215],
      [-78.805311749444, 42.844979406608],
      [-78.805574958895, 42.845264719656],
      [-78.805905760933, 42.84544271675],
      [-78.806148809066, 42.845520844837],
      [-78.806800412367, 42.845794680451],
      [-78.807194658704, 42.846060677872],
      [-78.807491829953, 42.846335201926],
      [-78.807794079433, 42.846670451877],
      [-78.807955317506, 42.846948813201],
      [-78.807946603997, 42.847223935692],
      [-78.807923116021, 42.84744192173],
      [-78.807933473512, 42.847620540988],
      [-78.808055793052, 42.847877541314],
      [-78.808173167092, 42.848109542859],
      [-78.8083000203, 42.848277214224],
      [-78.808392910475, 42.848452098219],
      [-78.808480972497, 42.848634137641],
      [-78.808690515364, 42.848840947204],
      [-78.808807685695, 42.849015783054],
      [-78.808954107893, 42.849222716401],
      [-78.808993746007, 42.849440578174],
      [-78.809023646518, 42.849651314008],
      [-78.809043407265, 42.849744167815],
      [-78.809024557055, 42.849901407337],
      [-78.809078607646, 42.850076367276],
      [-78.809152496519, 42.850365617943],
      [-78.80922613871, 42.850586985528],
      [-78.809162999876, 42.850874999437],
      [-78.809826781168, 42.851476454035],
      [-78.814852782664, 42.855526200783],
      [-78.816280000185, 42.856574999215],
      [-78.817133000472, 42.857009999503],
      [-78.81783151438, 42.857329068983],
      [-78.818666121391, 42.857672533366],
      [-78.819366999467, 42.857958999461],
      [-78.820288946711, 42.858578382274],
      [-78.821508999774, 42.859231999142],
      [-78.822381999872, 42.859490998894],
      [-78.826666397675, 42.860894193321],
      [-78.827662228512, 42.861778422001],
      [-78.827616643858, 42.861792677127],
      [-78.827321124686, 42.861885087123],
      [-78.826810589957, 42.862044731675],
      [-78.826136176709, 42.862255615881],
      [-78.825588754522, 42.86240412988],
      [-78.8252279506, 42.862498979858],
      [-78.825186443255, 42.862495604373],
      [-78.824401584832, 42.862808330922],
      [-78.823723666171, 42.863062104951],
      [-78.823301967603, 42.863219961983],
      [-78.82249295356, 42.863560976034],
      [-78.821971998074, 42.863706967912],
      [-78.821367157182, 42.864025748379],
      [-78.820870209203, 42.864130616111],
      [-78.820541994349, 42.864487043359],
      [-78.820615762978, 42.864708787187],
      [-78.82068703379, 42.864923021952],
      [-78.820750033144, 42.865079022904],
      [-78.82077905023, 42.865209959091],
      [-78.820778983964, 42.865412997054],
      [-78.820623056998, 42.865763953746],
      [-78.820451027318, 42.866092038212],
      [-78.820220021755, 42.866695988939],
      [-78.819845987308, 42.866964014857],
      [-78.819202958088, 42.867103987797],
      [-78.819106180115, 42.86710731181],
      [-78.818752002223, 42.867061967959],
      [-78.817821526124, 42.866816293747],
      [-78.817276740805, 42.86649644265],
      [-78.817152108693, 42.866401538888],
      [-78.816583036304, 42.866338010305],
      [-78.815428701034, 42.866038950642],
      [-78.814937026376, 42.865773036544],
      [-78.814443008188, 42.865483031408],
      [-78.814177478912, 42.865305199031],
    ],
  },
  {
    neighborhood: 'First Ward',
    coordinates: [
      [-78.848178443842, 42.860326077267],
      [-78.848198518476, 42.860360450987],
      [-78.848448715526, 42.860788864018],
      [-78.848548140587, 42.861004131739],
      [-78.84863893242, 42.861268680653],
      [-78.848725969237, 42.861692315364],
      [-78.848767245627, 42.861840998265],
      [-78.84881754205, 42.861923946424],
      [-78.848969340729, 42.862134394903],
      [-78.849329540496, 42.862687701835],
      [-78.850097437994, 42.863048637054],
      [-78.850269617304, 42.863028869201],
      [-78.850316330119, 42.863038873424],
      [-78.850532502459, 42.863112690003],
      [-78.850635989961, 42.863148028078],
      [-78.850661992382, 42.863143010725],
      [-78.850716049826, 42.863104994886],
      [-78.850757234542, 42.863118263454],
      [-78.850660386675, 42.86323685673],
      [-78.850783636453, 42.863392063125],
      [-78.850982432282, 42.863509819855],
      [-78.851212503194, 42.863567609239],
      [-78.851502283347, 42.86362615405],
      [-78.851882921116, 42.863630974729],
      [-78.852249668991, 42.8635917211],
      [-78.852375024619, 42.863598964199],
      [-78.852741951615, 42.863584978813],
      [-78.853335009932, 42.863520962094],
      [-78.853546035347, 42.863476033613],
      [-78.853757045978, 42.863405637386],
      [-78.853840018311, 42.86335600728],
      [-78.853946027118, 42.863314978341],
      [-78.854046993888, 42.863306982413],
      [-78.854339054694, 42.863329009593],
      [-78.854630009404, 42.863295970028],
      [-78.854983052076, 42.863234004909],
      [-78.855052053889, 42.863209978887],
      [-78.855162984787, 42.863189040985],
      [-78.855228388586, 42.863192879991],
      [-78.855292588253, 42.863206482069],
      [-78.855402945827, 42.863197965714],
      [-78.85584065311, 42.863110179005],
      [-78.856055958737, 42.863066996551],
      [-78.856343960583, 42.863020006161],
      [-78.856502864684, 42.862959606384],
      [-78.856635126632, 42.862897288586],
      [-78.856831901472, 42.862801499186],
      [-78.856971020202, 42.862728018922],
      [-78.857112979974, 42.862607981006],
      [-78.857181972549, 42.862521018018],
      [-78.857241009875, 42.862399996246],
      [-78.857284984284, 42.862269038678],
      [-78.85728802685, 42.862149005154],
      [-78.857247995758, 42.86182496011],
      [-78.85728503199, 42.861406025066],
      [-78.857327992685, 42.86130004216],
      [-78.857342983191, 42.861191041101],
      [-78.857321051702, 42.861066988393],
      [-78.857193051898, 42.860764999535],
      [-78.85709502597, 42.860451013555],
      [-78.857018065909, 42.860295601513],
      [-78.856041027573, 42.858892000446],
      [-78.855978966584, 42.858827015949],
      [-78.855796998016, 42.858683961093],
      [-78.855491012853, 42.858498988267],
      [-78.855235971237, 42.858286996676],
      [-78.854955052418, 42.857969993233],
      [-78.854889052341, 42.857827977871],
      [-78.85475798148, 42.857387970615],
      [-78.854758039323, 42.857326023166],
      [-78.854787044286, 42.85727102256],
      [-78.854841998917, 42.857220008735],
      [-78.856434956193, 42.85696901255],
      [-78.85675197511, 42.856903035411],
      [-78.857039966685, 42.856819038527],
      [-78.858050005435, 42.856414992312],
      [-78.859471992174, 42.855876021214],
      [-78.859668995769, 42.855853973782],
      [-78.859760002385, 42.855865036651],
      [-78.860234999034, 42.856054015056],
      [-78.860659358881, 42.856252376578],
      [-78.860810663196, 42.856363224945],
      [-78.860933407395, 42.856540363953],
      [-78.860996710483, 42.856705783798],
      [-78.861027719351, 42.856975051986],
      [-78.861090766401, 42.85715144165],
      [-78.861272193315, 42.857691484064],
      [-78.861428009779, 42.858050121545],
      [-78.861573283567, 42.858540321029],
      [-78.861610215853, 42.858875513474],
      [-78.861617054645, 42.858989909349],
      [-78.861604820075, 42.859424177757],
      [-78.861575744143, 42.859709155696],
      [-78.861486064169, 42.860031778889],
      [-78.86142005774, 42.860299828591],
      [-78.861308115788, 42.860616684816],
      [-78.861166189337, 42.860938650444],
      [-78.860987850946, 42.861221745994],
      [-78.860720589617, 42.86147628639],
      [-78.860409193768, 42.861702833305],
      [-78.860336255885, 42.861736011179],
      [-78.86033095372, 42.861537042518],
      [-78.860246157091, 42.860743826936],
      [-78.860195008108, 42.860694017777],
      [-78.860102345026, 42.86067643443],
      [-78.860099866085, 42.860568546498],
      [-78.859831066342, 42.860570649804],
      [-78.859922904787, 42.86397395497],
      [-78.860079122604, 42.863997870077],
      [-78.860181738143, 42.863956472679],
      [-78.860578956256, 42.864009025443],
      [-78.861100037721, 42.864095961201],
      [-78.861577947577, 42.864154010439],
      [-78.861745023495, 42.864158000994],
      [-78.862292037419, 42.864128987603],
      [-78.862723000014, 42.864132974449],
      [-78.86310499453, 42.864078019127],
      [-78.864173965725, 42.86385596395],
      [-78.86436697677, 42.86375003881],
      [-78.865745026731, 42.862847010918],
      [-78.86594201213, 42.862700971838],
      [-78.866558060436, 42.862306031033],
      [-78.866641966359, 42.862264026853],
      [-78.866795050077, 42.862242011927],
      [-78.86738894509, 42.862182036169],
      [-78.867421544565, 42.862175262107],
      [-78.867587974148, 42.862172286996],
      [-78.867601042311, 42.862176031],
      [-78.867638026333, 42.862195389454],
      [-78.868068319725, 42.862554048692],
      [-78.868451991147, 42.862873842615],
      [-78.868534218441, 42.863742322457],
      [-78.868572617429, 42.864348142634],
      [-78.868586729494, 42.864570802601],
      [-78.868542048624, 42.864876022881],
      [-78.868619996998, 42.865687955449],
      [-78.868646094325, 42.86601959829],
      [-78.867922521928, 42.866368106503],
      [-78.867995238473, 42.866451326214],
      [-78.868613423672, 42.866345928584],
      [-78.868643948161, 42.866387997474],
      [-78.868684021057, 42.866424006548],
      [-78.868741812554, 42.866461672867],
      [-78.868819024294, 42.866511996515],
      [-78.86885904898, 42.866555031006],
      [-78.868967408679, 42.866730769182],
      [-78.869409884089, 42.867678037342],
      [-78.869437990651, 42.867738209278],
      [-78.869441022472, 42.867745978747],
      [-78.86945331522, 42.867771013897],
      [-78.869862815582, 42.868647660657],
      [-78.870229705954, 42.869237217449],
      [-78.870448032296, 42.869659041269],
      [-78.870566987436, 42.869838777966],
      [-78.87062405015, 42.869924995163],
      [-78.870681998762, 42.870050976635],
      [-78.870698049468, 42.870149023941],
      [-78.870734966119, 42.870246005215],
      [-78.870849974025, 42.870382029393],
      [-78.871018997963, 42.870632012217],
      [-78.871146941671, 42.870784975519],
      [-78.871253761889, 42.8708827072],
      [-78.871319552966, 42.870988418953],
      [-78.871520174337, 42.871122150245],
      [-78.871767956329, 42.871332981846],
      [-78.871959998822, 42.871448028204],
      [-78.872103958857, 42.871584961148],
      [-78.872154977118, 42.871607993437],
      [-78.872189994804, 42.871612029924],
      [-78.872233006686, 42.871601028684],
      [-78.872249698591, 42.871608430521],
      [-78.872372154174, 42.871692876684],
      [-78.872346931229, 42.871793732192],
      [-78.872345367893, 42.871794957743],
      [-78.872279009002, 42.871846983564],
      [-78.872193955962, 42.871950976958],
      [-78.872107657833, 42.872084880684],
      [-78.872076023192, 42.872133965986],
      [-78.871986956192, 42.872385035405],
      [-78.871914692076, 42.87260543226],
      [-78.871874441072, 42.872728191975],
      [-78.871816987171, 42.872910524154],
      [-78.871783026744, 42.873006988633],
      [-78.869857045327, 42.87266397261],
      [-78.869207001335, 42.872550018622],
      [-78.868011053986, 42.872344958438],
      [-78.864423000499, 42.871720999115],
      [-78.861630999536, 42.871232999499],
      [-78.854870999989, 42.870054998612],
      [-78.847549999684, 42.868751998658],
      [-78.845995000221, 42.868474998881],
      [-78.845980732022, 42.868471969947],
      [-78.845982993467, 42.868464989815],
      [-78.845742860673, 42.868421462702],
      [-78.843500019753, 42.868022043301],
      [-78.846771999396, 42.862344998783],
      [-78.848178443842, 42.860326077267],
    ],
  },
  {
    neighborhood: 'Seneca Babcock',
    coordinates: [
      [-78.828727029865, 42.87843901877],
      [-78.815797992623, 42.877930038293],
      [-78.816440004362, 42.877003996851],
      [-78.816698008945, 42.876641984512],
      [-78.817157987328, 42.876002034574],
      [-78.817845053476, 42.875040986735],
      [-78.819528390157, 42.872689089293],
      [-78.819977946597, 42.872064035218],
      [-78.821904992275, 42.869289038314],
      [-78.819930573637, 42.866903402554],
      [-78.820220021755, 42.866695988939],
      [-78.820451027318, 42.866092038212],
      [-78.820623056998, 42.865763953746],
      [-78.820778983964, 42.865412997054],
      [-78.82077905023, 42.865209959091],
      [-78.820750033144, 42.865079022904],
      [-78.82068703379, 42.864923021952],
      [-78.820615762978, 42.864708787187],
      [-78.820541994349, 42.864487043359],
      [-78.820870209203, 42.864130616111],
      [-78.821367157182, 42.864025748379],
      [-78.821971998074, 42.863706967912],
      [-78.82249295356, 42.863560976034],
      [-78.823301967603, 42.863219961983],
      [-78.823723666171, 42.863062104951],
      [-78.824401584832, 42.862808330922],
      [-78.825186443255, 42.862495604373],
      [-78.8252279506, 42.862498979858],
      [-78.825588754522, 42.86240412988],
      [-78.826136176709, 42.862255615881],
      [-78.826810589957, 42.862044731675],
      [-78.827616643858, 42.861792677127],
      [-78.827877974657, 42.861710956662],
      [-78.828040010763, 42.86159802636],
      [-78.828349999319, 42.861466995339],
      [-78.82954205251, 42.861055035039],
      [-78.83069396471, 42.860673039252],
      [-78.830924055281, 42.860586005858],
      [-78.831084049088, 42.860544989338],
      [-78.831233977972, 42.860548968802],
      [-78.831368991406, 42.860571005618],
      [-78.831470888282, 42.860577477116],
      [-78.831788537635, 42.860674889543],
      [-78.832225062511, 42.86083963264],
      [-78.832542309602, 42.860997352714],
      [-78.832620821237, 42.861029383801],
      [-78.832677397614, 42.861052465742],
      [-78.833888049664, 42.861568992391],
      [-78.837352052628, 42.86299296143],
      [-78.837522987616, 42.863076991766],
      [-78.837624943324, 42.863150011363],
      [-78.838393984613, 42.863482004645],
      [-78.839206970733, 42.863806032867],
      [-78.839576006543, 42.8639659717],
      [-78.840005907491, 42.864090051945],
      [-78.84040299674, 42.864195972874],
      [-78.84057505467, 42.864225037323],
      [-78.840716983287, 42.864236026095],
      [-78.841161960408, 42.864173986015],
      [-78.841625001227, 42.864053983824],
      [-78.841662619187, 42.864040684539],
      [-78.841905017266, 42.863954986808],
      [-78.842062921236, 42.863868876376],
      [-78.842102959418, 42.863847041837],
      [-78.842107953846, 42.863821032924],
      [-78.842071007872, 42.863775995297],
      [-78.842093612053, 42.863732684757],
      [-78.842675024334, 42.863431018801],
      [-78.843027006409, 42.863272965916],
      [-78.843236038246, 42.8631800429],
      [-78.843572008012, 42.862979037986],
      [-78.84380451068, 42.862829971994],
      [-78.844326968183, 42.862495000914],
      [-78.844387757894, 42.862459229577],
      [-78.844903058285, 42.862155993437],
      [-78.845092022804, 42.862014041529],
      [-78.845557053323, 42.861633027065],
      [-78.845683969119, 42.861504955511],
      [-78.845869983703, 42.861353016553],
      [-78.845959512869, 42.861294221802],
      [-78.846160946532, 42.861142984283],
      [-78.846232986284, 42.861028013929],
      [-78.84625502822, 42.86091598506],
      [-78.846262960231, 42.860764005034],
      [-78.846251990519, 42.86036703668],
      [-78.846214998944, 42.860275992595],
      [-78.846110000631, 42.860095037838],
      [-78.845912978526, 42.859804001004],
      [-78.845768023237, 42.859626010169],
      [-78.845739016051, 42.859625995631],
      [-78.845644057245, 42.859639994788],
      [-78.845633005968, 42.859600029342],
      [-78.845644054917, 42.85951196097],
      [-78.845603960556, 42.85943398607],
      [-78.84545196976, 42.859321959739],
      [-78.845414961518, 42.859271972952],
      [-78.845367983784, 42.859161996261],
      [-78.845294991498, 42.858850039399],
      [-78.845186015874, 42.858538031539],
      [-78.845128016199, 42.858228992091],
      [-78.845139020453, 42.858153980739],
      [-78.845174943073, 42.8580900158],
      [-78.8452619708, 42.857977962663],
      [-78.845440982173, 42.85780996408],
      [-78.845561030386, 42.857732995276],
      [-78.845677002566, 42.857684975277],
      [-78.845812517627, 42.857676927246],
      [-78.845974621092, 42.857766787056],
      [-78.846129130766, 42.857862041119],
      [-78.846245934988, 42.857973272362],
      [-78.846413549679, 42.858145514848],
      [-78.846739766416, 42.858555730051],
      [-78.847130940966, 42.859060056483],
      [-78.847514015359, 42.859591713995],
      [-78.847660028215, 42.859730754578],
      [-78.847893523789, 42.859958704485],
      [-78.848061280408, 42.860125456386],
      [-78.848178443842, 42.860326077267],
      [-78.846771999396, 42.862344998783],
      [-78.843500019753, 42.868022043301],
      [-78.845742860673, 42.868421462702],
      [-78.845982993467, 42.868464989815],
      [-78.844952944622, 42.871645015152],
      [-78.844090995735, 42.874301031351],
      [-78.844075572506, 42.876342520863],
      [-78.844084998723, 42.878928989814],
      [-78.842560970322, 42.878657981457],
      [-78.841035008534, 42.878400973628],
      [-78.840148940941, 42.878242022612],
      [-78.839844950879, 42.878166967371],
      [-78.837344042084, 42.877854956879],
      [-78.833425912176, 42.876395368773],
      [-78.832929037702, 42.877026968996],
      [-78.83117801976, 42.877584022551],
      [-78.829209819267, 42.878235221987],
      [-78.828727029865, 42.87843901877],
    ],
  },
  {
    neighborhood: 'Pratt-Willert',
    coordinates: [
      [-78.853912023388, 42.880638015259],
      [-78.854094024254, 42.879771030066],
      [-78.854345982553, 42.879012972459],
      [-78.857515016405, 42.879562994926],
      [-78.859942952056, 42.879983991168],
      [-78.864773016811, 42.880818957175],
      [-78.869107012562, 42.881570026089],
      [-78.867398039588, 42.886854977375],
      [-78.866704017282, 42.888995954162],
      [-78.865594971915, 42.892389966125],
      [-78.8643730236, 42.892909018677],
      [-78.860420758745, 42.89440379845],
      [-78.858874237063, 42.89503269303],
      [-78.853982644263, 42.896848419157],
      [-78.853967998161, 42.896779039565],
      [-78.853963053369, 42.894843532392],
      [-78.85396463261, 42.893776944057],
      [-78.853967105606, 42.893349610424],
      [-78.85396904792, 42.893013998857],
      [-78.853967981751, 42.891043024214],
      [-78.853964972223, 42.889790975131],
      [-78.85395301606, 42.887820007113],
      [-78.853936054236, 42.885151956698],
      [-78.853928030281, 42.88334796551],
      [-78.853917976809, 42.881855031714],
      [-78.853912023388, 42.880638015259],
    ],
  },
  {
    neighborhood: 'Broadway Fillmore',
    coordinates: [
      [-78.825464939923, 42.895417961619],
      [-78.825635970626, 42.884465005142],
      [-78.825649993237, 42.882713030993],
      [-78.826874997314, 42.880996967686],
      [-78.827649362366, 42.879907951548],
      [-78.82816949612, 42.879177274094],
      [-78.828460008102, 42.87877101712],
      [-78.828727029865, 42.87843901877],
      [-78.829209819267, 42.878235221987],
      [-78.83117801976, 42.877584022551],
      [-78.832929037702, 42.877026968996],
      [-78.833425912176, 42.876395368773],
      [-78.837344042084, 42.877854956879],
      [-78.839844950879, 42.878166967371],
      [-78.840148940941, 42.878242022612],
      [-78.841035008534, 42.878400973628],
      [-78.842560970322, 42.878657981457],
      [-78.844084998723, 42.878928989814],
      [-78.845671056167, 42.87920896582],
      [-78.848933952303, 42.879781010365],
      [-78.853912023388, 42.880638015259],
      [-78.853917976809, 42.881855031714],
      [-78.853928030281, 42.88334796551],
      [-78.853936054236, 42.885151956698],
      [-78.85395301606, 42.887820007113],
      [-78.853964972223, 42.889790975131],
      [-78.853967981751, 42.891043024214],
      [-78.85396904792, 42.893013998857],
      [-78.853967105606, 42.893349610424],
      [-78.85396463261, 42.893776944057],
      [-78.853963053369, 42.894843532392],
      [-78.853967998161, 42.896779039565],
      [-78.853982644263, 42.896848419157],
      [-78.852562567036, 42.897375483411],
      [-78.850991795573, 42.898483614636],
      [-78.84857105358, 42.900153953015],
      [-78.846707209489, 42.902121107395],
      [-78.845646615023, 42.903714629476],
      [-78.844644012865, 42.903691042796],
      [-78.841547724639, 42.903646750292],
      [-78.835509970265, 42.903602976608],
      [-78.829944038968, 42.903544960861],
      [-78.8289719445, 42.903532956881],
      [-78.828958002141, 42.900899014371],
      [-78.82872193347, 42.894971237479],
      [-78.828720343947, 42.894931327784],
      [-78.828255051953, 42.895000964186],
      [-78.828108976063, 42.895022963819],
      [-78.82724500434, 42.895153004635],
      [-78.826350044365, 42.895286956756],
      [-78.825936972074, 42.895347962188],
      [-78.825464939923, 42.895417961619],
    ],
  },
  {
    neighborhood: 'Central Park',
    coordinates: [
      [-78.836479299194, 42.958375319998],
      [-78.83644066481, 42.958339986627],
      [-78.826075221261, 42.940099961668],
      [-78.831504000025, 42.940173011582],
      [-78.843325970297, 42.940304998173],
      [-78.844158999319, 42.940312008989],
      [-78.843964950385, 42.950283028228],
      [-78.843800947764, 42.958460031998],
      [-78.843803655573, 42.958486859326],
      [-78.843800809494, 42.958486818991],
      [-78.842458674918, 42.958468600282],
      [-78.838961368855, 42.958419186027],
      [-78.83828282719, 42.958409037974],
      [-78.836856606498, 42.958382366318],
      [-78.836479299194, 42.958375319998],
    ],
  },
  {
    neighborhood: 'North Park',
    coordinates: [
      [-78.843803655573, 42.958486859326],
      [-78.843800947764, 42.958460031998],
      [-78.843964950385, 42.950283028228],
      [-78.844158999319, 42.940312008989],
      [-78.844769536912, 42.940710243692],
      [-78.845662857768, 42.941484718996],
      [-78.846834515907, 42.942299414757],
      [-78.848450356235, 42.942908724803],
      [-78.849947000537, 42.943405986226],
      [-78.850900487421, 42.943475195266],
      [-78.854573794369, 42.943875243647],
      [-78.856951058226, 42.943915002765],
      [-78.868077999795, 42.944073999423],
      [-78.877661088252, 42.944071402047],
      [-78.878308003917, 42.944067038058],
      [-78.878418784214, 42.944130320191],
      [-78.878376553824, 42.958633404865],
      [-78.875155052337, 42.958654353216],
      [-78.869627318543, 42.958700895025],
      [-78.865556712119, 42.958688709768],
      [-78.861260072882, 42.958671441092],
      [-78.858663190873, 42.958653365169],
      [-78.856070547857, 42.95864345176],
      [-78.854282970254, 42.958636378584],
      [-78.853655345369, 42.958631345833],
      [-78.853143999756, 42.958627407543],
      [-78.852026006942, 42.958610144401],
      [-78.850907091181, 42.958595273359],
      [-78.850122076032, 42.958584758362],
      [-78.847464382107, 42.95854050358],
      [-78.846659277139, 42.958527267346],
      [-78.843803655573, 42.958486859326],
    ],
  },
  {
    neighborhood: 'Upper West Side',
    coordinates: [
      [-78.888741737876, 42.914610551025],
      [-78.888937998721, 42.914574257131],
      [-78.892700999794, 42.912659999471],
      [-78.89625599985, 42.912832998869],
      [-78.8977559994, 42.912935998674],
      [-78.897932000554, 42.912946999231],
      [-78.89970399996, 42.913064999335],
      [-78.901680000053, 42.913031999217],
      [-78.901762842068, 42.913043233096],
      [-78.901763316761, 42.913055743903],
      [-78.901780255758, 42.913870665712],
      [-78.901809072919, 42.914516940007],
      [-78.901836779969, 42.914947765557],
      [-78.901877040469, 42.915341086387],
      [-78.901802888212, 42.915790930587],
      [-78.901753597877, 42.916118927756],
      [-78.90167857711, 42.916400159934],
      [-78.901540505061, 42.91681271187],
      [-78.901415129418, 42.917215860674],
      [-78.901252190531, 42.917750258161],
      [-78.901164563396, 42.918059627007],
      [-78.901102233704, 42.918331455822],
      [-78.901052793326, 42.918631350891],
      [-78.901052163025, 42.918643604593],
      [-78.900556910989, 42.919944910025],
      [-78.900126823354, 42.92134402759],
      [-78.899858590925, 42.921875794642],
      [-78.89955676153, 42.92267286116],
      [-78.899318704675, 42.923479118416],
      [-78.899319996986, 42.92373198377],
      [-78.899314469838, 42.923748957298],
      [-78.89931373298, 42.923762728137],
      [-78.899307442207, 42.923769540332],
      [-78.899197224201, 42.924650383643],
      [-78.899137893817, 42.925512351051],
      [-78.899129502314, 42.926364811047],
      [-78.899120439536, 42.927086128457],
      [-78.899100725754, 42.927622434954],
      [-78.89759401771, 42.92804803135],
      [-78.896921476734, 42.928430998038],
      [-78.89656300708, 42.92867743667],
      [-78.895860656247, 42.929529292771],
      [-78.895099998855, 42.930474006505],
      [-78.894397062065, 42.93097256019],
      [-78.893712999918, 42.931616999394],
      [-78.893346999955, 42.932315998866],
      [-78.893102771485, 42.932959279227],
      [-78.892972000012, 42.933278999489],
      [-78.892652657735, 42.933733267625],
      [-78.892022999789, 42.934320998849],
      [-78.890825886383, 42.935165421582],
      [-78.889264482823, 42.936266290228],
      [-78.888297999405, 42.936904999107],
      [-78.887571790115, 42.937172738575],
      [-78.886606969349, 42.937257155174],
      [-78.886665967879, 42.937021999762],
      [-78.887907981246, 42.920174014447],
      [-78.888139006994, 42.916810028458],
      [-78.888153972052, 42.914966011991],
      [-78.888150746142, 42.914946653299],
      [-78.888741737876, 42.914610551025],
    ],
  },
  {
    neighborhood: 'Elmwood Bidwell',
    coordinates: [
      [-78.873788000428, 42.932938998964],
      [-78.873194482334, 42.932572332547],
      [-78.872303000454, 42.932692998838],
      [-78.871778000073, 42.932781999312],
      [-78.870863000152, 42.932710999378],
      [-78.869873075487, 42.932474037825],
      [-78.868835442177, 42.932158671741],
      [-78.868614999554, 42.932067998922],
      [-78.868007999722, 42.931672999468],
      [-78.86732300019, 42.931413999449],
      [-78.866978000233, 42.931215999069],
      [-78.866926006962, 42.930969947837],
      [-78.866907000013, 42.930879999507],
      [-78.866536130546, 42.930466968918],
      [-78.866362705402, 42.930240033143],
      [-78.8660945401, 42.929822965301],
      [-78.865778999935, 42.92948399936],
      [-78.859880027972, 42.927294090483],
      [-78.853995976564, 42.925303982817],
      [-78.853995430102, 42.925303674435],
      [-78.857280993474, 42.922197009179],
      [-78.864259636808, 42.915338882935],
      [-78.864481999871, 42.915348999237],
      [-78.869974059608, 42.915399285335],
      [-78.870236491887, 42.915406408528],
      [-78.873514999503, 42.915428999294],
      [-78.877046999868, 42.915464999303],
      [-78.880829869389, 42.915495739401],
      [-78.882600999627, 42.915488998621],
      [-78.885666000073, 42.915410999273],
      [-78.886797000245, 42.915380999396],
      [-78.88815087373, 42.915347781806],
      [-78.888139006994, 42.916810028458],
      [-78.887907981246, 42.920174014447],
      [-78.886665967879, 42.937021999762],
      [-78.886606969349, 42.937257155174],
      [-78.885953826734, 42.937314297237],
      [-78.883761039518, 42.937262010987],
      [-78.882217000318, 42.936960998988],
      [-78.881189034642, 42.936448016693],
      [-78.880376000155, 42.935566999199],
      [-78.8798379682, 42.93495803693],
      [-78.879356000012, 42.934686999083],
      [-78.878498676599, 42.934351515336],
      [-78.877474055727, 42.934186953985],
      [-78.876045085249, 42.934022320722],
      [-78.874675005092, 42.933923976302],
      [-78.873969999982, 42.93331999947],
      [-78.873788000428, 42.932938998964],
    ],
  },
  {
    neighborhood: 'Parkside',
    coordinates: [
      [-78.837992706382, 42.940245606138],
      [-78.839073960213, 42.939250034605],
      [-78.83930500021, 42.939037980516],
      [-78.840319939015, 42.938102973065],
      [-78.841572977877, 42.936948007647],
      [-78.842119010625, 42.936440033061],
      [-78.842866973241, 42.935746993898],
      [-78.843910951047, 42.934791980921],
      [-78.844796054609, 42.9339799693],
      [-78.845827967858, 42.933026965498],
      [-78.846409056378, 42.932478985003],
      [-78.846656999443, 42.932244017835],
      [-78.847482026293, 42.931463989105],
      [-78.848153970417, 42.93082902718],
      [-78.848512979191, 42.930491005152],
      [-78.849551051834, 42.929503006615],
      [-78.850967053519, 42.928164986721],
      [-78.851291029519, 42.927859019697],
      [-78.851507255404, 42.92765539138],
      [-78.851507809532, 42.927655488206],
      [-78.851888727568, 42.927295164257],
      [-78.85190130661, 42.927294184119],
      [-78.851957999092, 42.927229965635],
      [-78.853995430102, 42.925303674435],
      [-78.853995976564, 42.925303982817],
      [-78.859880027972, 42.927294090483],
      [-78.865778999935, 42.92948399936],
      [-78.8660945401, 42.929822965301],
      [-78.866362705402, 42.930240033143],
      [-78.866536130546, 42.930466968918],
      [-78.866907000013, 42.930879999507],
      [-78.866926006962, 42.930969947837],
      [-78.866978000233, 42.931215999069],
      [-78.86732300019, 42.931413999449],
      [-78.868007999722, 42.931672999468],
      [-78.868614999554, 42.932067998922],
      [-78.868835442177, 42.932158671741],
      [-78.869873075487, 42.932474037825],
      [-78.870863000152, 42.932710999378],
      [-78.871778000073, 42.932781999312],
      [-78.872303000454, 42.932692998838],
      [-78.873194482334, 42.932572332547],
      [-78.873788000428, 42.932938998964],
      [-78.873969999982, 42.93331999947],
      [-78.874675005092, 42.933923976302],
      [-78.876045085249, 42.934022320722],
      [-78.877473547014, 42.934186895878],
      [-78.877835895162, 42.934821487856],
      [-78.878190019179, 42.935808989245],
      [-78.87828844365, 42.936333661469],
      [-78.878437132874, 42.937115270958],
      [-78.878602945742, 42.938570994535],
      [-78.878575966658, 42.940564966532],
      [-78.878375057157, 42.942738375655],
      [-78.87837126075, 42.944103172531],
      [-78.878308003917, 42.944067038058],
      [-78.877661088252, 42.944071402047],
      [-78.868077999795, 42.944073999423],
      [-78.856951058226, 42.943915002765],
      [-78.854573794369, 42.943875243647],
      [-78.850900487421, 42.943475195266],
      [-78.849947000537, 42.943405986226],
      [-78.848450356235, 42.942908724803],
      [-78.846834515907, 42.942299414757],
      [-78.845662857768, 42.941484718996],
      [-78.844769536912, 42.940710243692],
      [-78.844158999319, 42.940312008989],
      [-78.843325970297, 42.940304998173],
      [-78.837992706382, 42.940245606138],
    ],
  },
  {
    neighborhood: 'West Side',
    coordinates: [
      [-78.896389226915, 42.896797644102],
      [-78.897791997846, 42.898256970031],
      [-78.89851832062, 42.899039360605],
      [-78.900014978913, 42.90124699859],
      [-78.90074796695, 42.90250402479],
      [-78.901682677425, 42.902339589772],
      [-78.901683255771, 42.902451997671],
      [-78.901864583748, 42.903022908489],
      [-78.901881521766, 42.903837831715],
      [-78.90178541745, 42.904971563241],
      [-78.901700993353, 42.905899176665],
      [-78.90162786402, 42.906545735368],
      [-78.901604498444, 42.906957969108],
      [-78.90153112601, 42.907557690829],
      [-78.901558056743, 42.907838639932],
      [-78.901585808193, 42.908278833598],
      [-78.90157518518, 42.908691031784],
      [-78.901641937719, 42.909280996113],
      [-78.901673497585, 42.910461207994],
      [-78.901704336803, 42.911500910192],
      [-78.901752193143, 42.912762527083],
      [-78.901762842068, 42.913043233096],
      [-78.901680000053, 42.913031999217],
      [-78.89970399996, 42.913064999335],
      [-78.897932000554, 42.912946999231],
      [-78.8977559994, 42.912935998674],
      [-78.89625599985, 42.912832998869],
      [-78.892700999794, 42.912659999471],
      [-78.888937998721, 42.914574257131],
      [-78.888741737876, 42.914610551025],
      [-78.88729303061, 42.913075974999],
      [-78.887481942224, 42.912981044006],
      [-78.886138037268, 42.911323960796],
      [-78.8869369719, 42.910919991017],
      [-78.885430022184, 42.909322015491],
      [-78.885971009802, 42.909045038765],
      [-78.8844949671, 42.907465987591],
      [-78.883045025129, 42.905883959788],
      [-78.882670002423, 42.905432016431],
      [-78.881903023702, 42.905421960823],
      [-78.882017941642, 42.902995969672],
      [-78.881690883786, 42.902335494181],
      [-78.882062294738, 42.901756872688],
      [-78.883528044099, 42.901000953667],
      [-78.884556046509, 42.900472979702],
      [-78.892546958037, 42.896433002966],
      [-78.892986162347, 42.896900232989],
      [-78.894019038576, 42.897999031583],
      [-78.896339999848, 42.896825998809],
      [-78.896389226915, 42.896797644102],
    ],
  },
  {
    neighborhood: 'University Heights',
    coordinates: [
      [-78.807551700736, 42.959004635753],
      [-78.807556362262, 42.956558827279],
      [-78.804313525696, 42.956597030591],
      [-78.803558329304, 42.956558700233],
      [-78.803558192255, 42.95455603294],
      [-78.804382443059, 42.954586684416],
      [-78.808654703609, 42.954658955167],
      [-78.808754275569, 42.952259604232],
      [-78.810467326194, 42.952239754927],
      [-78.810812164922, 42.950012253672],
      [-78.810818769182, 42.950010658874],
      [-78.810839284664, 42.949914845395],
      [-78.810845036091, 42.949887989627],
      [-78.810891022615, 42.949825779955],
      [-78.810964117191, 42.949748562932],
      [-78.811029028012, 42.949679991577],
      [-78.811088371209, 42.949642927899],
      [-78.811125847487, 42.94961952252],
      [-78.811173109711, 42.949590005014],
      [-78.811234016489, 42.949551965918],
      [-78.811353316169, 42.949512005563],
      [-78.811445959593, 42.949480972502],
      [-78.81153703712, 42.949462963162],
      [-78.811648054005, 42.94944100976],
      [-78.812059809901, 42.949439054402],
      [-78.8124980497, 42.94943697163],
      [-78.812650021754, 42.949414975769],
      [-78.812675155298, 42.949411565824],
      [-78.812787038352, 42.949385397488],
      [-78.812899045257, 42.949356968359],
      [-78.812951175988, 42.949335263202],
      [-78.813045770773, 42.949292445649],
      [-78.813105854334, 42.949262119329],
      [-78.813158778754, 42.949235407301],
      [-78.813213044915, 42.949208016495],
      [-78.813275087858, 42.949157295435],
      [-78.813299964627, 42.94913695827],
      [-78.813363756096, 42.949074709126],
      [-78.813398603819, 42.949035509552],
      [-78.813453648676, 42.948954719152],
      [-78.813462996691, 42.948941000924],
      [-78.813681041659, 42.948944980611],
      [-78.813689992932, 42.948945158845],
      [-78.813668941908, 42.947423034133],
      [-78.813647957795, 42.942495992133],
      [-78.81363404837, 42.940208967426],
      [-78.821567943393, 42.940108035252],
      [-78.825007969251, 42.940085980833],
      [-78.826075221261, 42.940099961668],
      [-78.830178882183, 42.94732256903],
      [-78.83644066481, 42.958339986627],
      [-78.836479299194, 42.958375319998],
      [-78.835953428618, 42.958365498265],
      [-78.831912012481, 42.958289629687],
      [-78.831154062679, 42.95827275218],
      [-78.829957596766, 42.958246525864],
      [-78.828863872214, 42.958222467577],
      [-78.82793640315, 42.958202159462],
      [-78.825189955414, 42.958141800019],
      [-78.824899947676, 42.958135552785],
      [-78.823845923597, 42.958112734685],
      [-78.819751256562, 42.958024200419],
      [-78.818877498454, 42.958005080781],
      [-78.818735235582, 42.95755709704],
      [-78.818733054791, 42.957557948624],
      [-78.817374664977, 42.958088420731],
      [-78.815793518186, 42.958705578487],
      [-78.814571848699, 42.959182052729],
      [-78.813943291544, 42.959428208752],
      [-78.813876064643, 42.959454759959],
      [-78.812123360814, 42.9601469766],
      [-78.810904920908, 42.960628206874],
      [-78.808555756195, 42.961456693551],
      [-78.808555878206, 42.959057541268],
      [-78.807551700736, 42.959004635753],
    ],
  },
  {
    neighborhood: 'Hamlin Park',
    coordinates: [
      [-78.850599483265, 42.927640573157],
      [-78.849586425201, 42.927627204349],
      [-78.846132014991, 42.927579029267],
      [-78.845603996172, 42.927574015194],
      [-78.842711975741, 42.927521002852],
      [-78.84269721509, 42.923666526643],
      [-78.843618058769, 42.923163503982],
      [-78.843579058501, 42.92299097792],
      [-78.843415837618, 42.914668916928],
      [-78.843615004727, 42.914671042504],
      [-78.849106974488, 42.914725023379],
      [-78.853989004433, 42.914962993454],
      [-78.8539940366, 42.922126995827],
      [-78.85399308455, 42.922872108268],
      [-78.853992982461, 42.922952042337],
      [-78.85399300957, 42.923763005887],
      [-78.853990959519, 42.924574039948],
      [-78.853993020902, 42.924871994053],
      [-78.853994641744, 42.925108765091],
      [-78.854011958806, 42.925288047211],
      [-78.851957999092, 42.927229965635],
      [-78.85190130661, 42.927294184119],
      [-78.851888727568, 42.927295164257],
      [-78.851507809532, 42.927655488206],
      [-78.85150499967, 42.927654998769],
      [-78.850635945376, 42.927631956679],
      [-78.850599483265, 42.927640573157],
    ],
  },
  {
    neighborhood: 'Fruit Belt',
    coordinates: [
      [-78.871873617233, 42.893324082779],
      [-78.871255993667, 42.895186011833],
      [-78.870728031013, 42.896804033025],
      [-78.86897100867, 42.902196962558],
      [-78.868374999982, 42.904018959405],
      [-78.867012992094, 42.904003997751],
      [-78.866769041059, 42.90406303072],
      [-78.866018006266, 42.903963011608],
      [-78.862574030026, 42.903944020501],
      [-78.859737012713, 42.903901011416],
      [-78.853977028192, 42.903831004054],
      [-78.848082951884, 42.903767019716],
      [-78.847064976064, 42.903747980986],
      [-78.845646615023, 42.903714629476],
      [-78.846707209489, 42.902121107395],
      [-78.84857105358, 42.900153953015],
      [-78.850991795573, 42.898483614636],
      [-78.852562567036, 42.897375483411],
      [-78.858874237063, 42.89503269303],
      [-78.860420758745, 42.89440379845],
      [-78.8643730236, 42.892909018677],
      [-78.865594971915, 42.892389966125],
      [-78.869651007454, 42.892944042293],
      [-78.871873617233, 42.893324082779],
    ],
  },
  {
    neighborhood: 'South Park',
    coordinates: [
      [-78.816280000185, 42.856574999215],
      [-78.814852782664, 42.855526200783],
      [-78.809826781168, 42.851476454035],
      [-78.809162999876, 42.850874999437],
      [-78.80922613871, 42.850586985528],
      [-78.809152496519, 42.850365617943],
      [-78.809078607646, 42.850076367276],
      [-78.809024557055, 42.849901407337],
      [-78.809043407265, 42.849744167815],
      [-78.809023646518, 42.849651314008],
      [-78.808993746007, 42.849440578174],
      [-78.808954107893, 42.849222716401],
      [-78.808807685695, 42.849015783054],
      [-78.808690515364, 42.848840947204],
      [-78.808480972497, 42.848634137641],
      [-78.808392910475, 42.848452098219],
      [-78.8083000203, 42.848277214224],
      [-78.808173167092, 42.848109542859],
      [-78.808055793052, 42.847877541314],
      [-78.807933473512, 42.847620540988],
      [-78.807923116021, 42.84744192173],
      [-78.807946603997, 42.847223935692],
      [-78.807955317506, 42.846948813201],
      [-78.807794079433, 42.846670451877],
      [-78.807491829953, 42.846335201926],
      [-78.807194658704, 42.846060677872],
      [-78.806800412367, 42.845794680451],
      [-78.806148809066, 42.845520844837],
      [-78.805905760933, 42.84544271675],
      [-78.805574958895, 42.845264719656],
      [-78.805311749444, 42.844979406608],
      [-78.805106959907, 42.844736853215],
      [-78.805018479035, 42.844433337659],
      [-78.804881537027, 42.844154925063],
      [-78.804759391147, 42.843940793354],
      [-78.804603426008, 42.843773174194],
      [-78.804476770444, 42.843655516754],
      [-78.804267628389, 42.843552309501],
      [-78.804053645522, 42.843452684205],
      [-78.803747465601, 42.843367526263],
      [-78.803543447633, 42.843339336532],
      [-78.803144882474, 42.843215055103],
      [-78.8028048206, 42.843158542858],
      [-78.802484318722, 42.843141292581],
      [-78.80213487602, 42.843177688268],
      [-78.801799958997, 42.843203337945],
      [-78.801343802564, 42.843268517057],
      [-78.801086655916, 42.843319025818],
      [-78.800635139234, 42.84332345661],
      [-78.800396843652, 42.843312473887],
      [-78.800188391675, 42.843302866416],
      [-78.799887142825, 42.843305927491],
      [-78.799600893848, 42.843296832453],
      [-78.799368058991, 42.843358009563],
      [-78.799101087544, 42.843376376208],
      [-78.798722174913, 42.843316352032],
      [-78.79864888789, 42.843184296587],
      [-78.7984766732, 42.843058646699],
      [-78.797879545042, 42.842834417186],
      [-78.797687871315, 42.842806580986],
      [-78.79755703312, 42.842787578942],
      [-78.79713632252, 42.84252770294],
      [-78.797040171735, 42.84246831065],
      [-78.796796819715, 42.842006202339],
      [-78.796537639738, 42.841627148424],
      [-78.796101215518, 42.841260283015],
      [-78.795746072862, 42.841094895019],
      [-78.79534286401, 42.841012618613],
      [-78.7950361957, 42.840882719324],
      [-78.796441339445, 42.838662874317],
      [-78.796607129538, 42.838400949758],
      [-78.796620002446, 42.838404331351],
      [-78.800329607211, 42.839378806531],
      [-78.800261194901, 42.841044820495],
      [-78.800779874348, 42.841158394498],
      [-78.800813098646, 42.839601508159],
      [-78.800815088881, 42.839531738358],
      [-78.800831775097, 42.838946707504],
      [-78.800855817546, 42.83809450761],
      [-78.800916454755, 42.837311692621],
      [-78.8009307351, 42.836467056749],
      [-78.800946893384, 42.835493624795],
      [-78.800978217079, 42.834459454986],
      [-78.801049673363, 42.831980367591],
      [-78.801656425848, 42.831982128171],
      [-78.805617570505, 42.831994057377],
      [-78.80735582285, 42.832001645394],
      [-78.808509693606, 42.832008471728],
      [-78.809554951612, 42.832006754422],
      [-78.812554652613, 42.832001645788],
      [-78.813702898499, 42.831999512461],
      [-78.815111680286, 42.832006960041],
      [-78.817656611309, 42.832017042879],
      [-78.818556027332, 42.832020515541],
      [-78.819696842461, 42.832025026087],
      [-78.820753776992, 42.832029870264],
      [-78.82389686097, 42.832044501523],
      [-78.823840941488, 42.835558988378],
      [-78.823738945159, 42.843331971679],
      [-78.82368897116, 42.847736956894],
      [-78.823601943156, 42.856063974789],
      [-78.823607790455, 42.85607589323],
      [-78.823603999537, 42.8563639991],
      [-78.823559786203, 42.856329713996],
      [-78.823437851924, 42.856683267513],
      [-78.823147709315, 42.857524533731],
      [-78.822914254833, 42.858204570484],
      [-78.822654393538, 42.858956188499],
      [-78.822577999585, 42.859173998679],
      [-78.822543961787, 42.859229051145],
      [-78.822428291175, 42.859416130306],
      [-78.822381999872, 42.859490998894],
      [-78.821508999774, 42.859231999142],
      [-78.820288946711, 42.858578382274],
      [-78.819366999467, 42.857958999461],
      [-78.818666121391, 42.857672533366],
      [-78.81783151438, 42.857329068983],
      [-78.817133000472, 42.857009999503],
      [-78.816280000185, 42.856574999215],
    ],
  },
  {
    neighborhood: 'Kaisertown',
    coordinates: [
      [-78.799520827451, 42.877728520437],
      [-78.799691004156, 42.876247871442],
      [-78.799599662993, 42.875515238987],
      [-78.799822581609, 42.87478873455],
      [-78.799944123022, 42.87176873983],
      [-78.799933447119, 42.871737668061],
      [-78.799894847763, 42.87173671482],
      [-78.799727213839, 42.87173257566],
      [-78.799494849072, 42.871726837253],
      [-78.79949746224, 42.871609733765],
      [-78.799550512654, 42.869232118426],
      [-78.799571346977, 42.867613138918],
      [-78.799574423016, 42.867276708014],
      [-78.799742641689, 42.867178780523],
      [-78.799822242267, 42.867132441265],
      [-78.799974035024, 42.866711411194],
      [-78.79998590775, 42.866158983222],
      [-78.799987628615, 42.866078901283],
      [-78.799999048349, 42.86481189818],
      [-78.800000486891, 42.864787926041],
      [-78.800076370147, 42.864794083999],
      [-78.80092952399, 42.864858236286],
      [-78.802174954812, 42.864825010054],
      [-78.807413316036, 42.864642246917],
      [-78.809776999625, 42.864197999081],
      [-78.810020999543, 42.863987999442],
      [-78.810344999888, 42.86371999936],
      [-78.810471264525, 42.863653992829],
      [-78.81066331336, 42.863549454618],
      [-78.810889926615, 42.863494322921],
      [-78.811151546843, 42.863434105064],
      [-78.811556546388, 42.86345885592],
      [-78.811737503067, 42.863544165097],
      [-78.811883114256, 42.863684435833],
      [-78.812162430992, 42.863945964353],
      [-78.81240354188, 42.864140653024],
      [-78.812799649434, 42.864481853904],
      [-78.813102379177, 42.86475549972],
      [-78.813288283679, 42.86489990983],
      [-78.813549527374, 42.86504730546],
      [-78.813553001147, 42.865072521004],
      [-78.813583946253, 42.865071044522],
      [-78.814177478912, 42.865305199031],
      [-78.814443008188, 42.865483031408],
      [-78.814937026376, 42.865773036544],
      [-78.815428701034, 42.866038950642],
      [-78.816583036304, 42.866338010305],
      [-78.817152108693, 42.866401538888],
      [-78.817276740805, 42.86649644265],
      [-78.817821526124, 42.866816293747],
      [-78.818752002223, 42.867061967959],
      [-78.819106180115, 42.86710731181],
      [-78.819202958088, 42.867103987797],
      [-78.819845987308, 42.866964014857],
      [-78.819930573637, 42.866903402554],
      [-78.821904992275, 42.869289038314],
      [-78.819977946597, 42.872064035218],
      [-78.819528390157, 42.872689089293],
      [-78.817845053476, 42.875040986735],
      [-78.817157987328, 42.876002034574],
      [-78.816698008945, 42.876641984512],
      [-78.816440004362, 42.877003996851],
      [-78.815797992623, 42.877930038293],
      [-78.808465029451, 42.877809005215],
      [-78.805522982272, 42.877782003285],
      [-78.803969046924, 42.877767992369],
      [-78.802942026113, 42.87775597114],
      [-78.801864997397, 42.877741011408],
      [-78.801256977907, 42.877734038604],
      [-78.800222002601, 42.877726038419],
      [-78.799520827451, 42.877728520437],
    ],
  },
  {
    neighborhood: 'MLK Park',
    coordinates: [
      [-78.845706368871, 42.903716034625],
      [-78.845003958758, 42.904601999923],
      [-78.844493831908, 42.906006491531],
      [-78.843585027626, 42.907879000366],
      [-78.843354055544, 42.908849986372],
      [-78.843314626232, 42.910705701172],
      [-78.843417041609, 42.914668929497],
      [-78.839118943335, 42.914622970061],
      [-78.835415024761, 42.914578036945],
      [-78.832414000224, 42.914543003033],
      [-78.82907696346, 42.914499969228],
      [-78.82427296924, 42.914450010029],
      [-78.824262038886, 42.910319004795],
      [-78.824233029483, 42.908426035264],
      [-78.828332006617, 42.906784036745],
      [-78.828982060452, 42.906516012326],
      [-78.8289719445, 42.903532956881],
      [-78.829944038968, 42.903544960861],
      [-78.835509970265, 42.903602976608],
      [-78.841547724639, 42.903646750292],
      [-78.844644012865, 42.903691042796],
      [-78.845706368871, 42.903716034625],
    ],
  },
]

export default neighborhoods
